import conversions from '@/Pages/VueClasses/RecipeIngredientsPrototype/conversions';
import { forEach } from 'lodash';

export default {
  uomType(val) {
    const weight = [
      'Ounce',
      'Gram',
      'LB',
      'Kilogram',
      'Milligram',
    ];

    const volume = [
      'Gallon',
      'Quart',
      'Pint',
      'Cup',
      'Fluid Ounce',
      'Tablespoon',
      'Teaspoon',
      'Litre',
      'Millilitre',
    ];

    const unit = [
      'Each',
      'Count',
      'Piece',
    ];

    if (unit.includes(val)) {
      return "Unit"
    }
    if (volume.includes(val)) {
      return "Volume"
    }
    if (weight.includes(val)) {
      return "Weight"
    }

    if (val != '') {
      return "Custom";
    }

    return "Not Found"
  },

  getSatFatPercentage(nutritionFactsSatFat = null, nutritionFactsCalories = null) {
    if (nutritionFactsSatFat > 0 && nutritionFactsCalories > 0) {
      return Math.round(((nutritionFactsSatFat * 9) / nutritionFactsCalories) * 100 * 10) / 10;
    }
    return 0;
  },

  getCalPercentage(nutritionFactsFat = null, nutritionFactsCalories = null) {
    if (nutritionFactsFat > 0 && nutritionFactsCalories > 0) {
      // console.log("getCalPercentage", nutritionFactsFat, nutritionFactsCalories, Math.round(((nutritionFactsFat * 4) / nutritionFactsCalories)  * 100 * 10) / 10);
      return Math.round(((nutritionFactsFat * 4) / nutritionFactsCalories) * 100 * 10) / 10;
    }
    return 0;
  },


  preferProductsCalculatedTotals(ing_prefer_products, isMilk = true) {

    // console.error("preferProductsCalculatedTotals isMilk", isMilk);

    let scale_val = 1;
    let scale_component_val = 1;

    let sum_product_data = [];

    let total_num = ing_prefer_products.length;

    if (total_num > 0) {

      let sum1 = 0, sum2 = 0, sum3 = 0, sum4 = 0, sum5 = 0, sum6 = 0, sum7 = 0, sum8 = 0, sum9 = 0, sum10 = 0,
        sum11 = 0, sum12 = 0, sum13 = 0, sum14 = 0, sum15 = 0, sum16 = 0, nutrition_facts_satfat = 0;
      for (let i = 0; i < ing_prefer_products.length; i++) {

        scale_val = this.getNutritionScaleFactor(ing_prefer_products[i]);

        sum1 += this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_mma') || 0;
        sum2 += this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_wgr') || 0;
        sum3 += this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_fru') || 0;
        sum4 += this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_mlk') || 0;
        sum5 += this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_veg') || 0;
        sum6 += this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_dg') || 0;
        sum7 += this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_ro') || 0;
        sum8 += this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_leg') || 0;
        sum9 += this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_star') || 0;
        sum10 += this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_other') || 0;

        //// console.log("sum11 helper", scale_val, this.getIngPreferProductComponentVal(ing_prefer_products[i],'component_nut_calories'))
        sum11 += this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_nut_calories') * scale_val || 0;
        sum12 += this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_nut_sodium') * scale_val || 0;
        sum13 += this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_nut_totalfat') * scale_val || 0;
        sum14 += this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_nut_protein') * scale_val || 0;
        sum15 += this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_nut_carbs') * scale_val || 0;
        sum16 += this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_nut_added_sugars') * scale_val || 0;
        nutrition_facts_satfat += this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_nut_satfat') * scale_val || 0;


        // // console.log("preferProductsCalculatedTotals sum1 mma final", nutrition_facts_satfat, this.getIngPreferProductComponentVal(ing_prefer_products[i], 'component_nut_satfat'), 'scale_val', scale_val);

      }

      var nutrition_facts_satfat_percent = this.getSatFatPercentage(nutrition_facts_satfat, sum11);

      let cals_percent = this.getCalPercentage(sum16, sum11);

      // // console.log("sum1 mma final", nutrition_facts_satfat_percent, nutrition_facts_satfat, scale_val);

      // if (!isMilk) {
      //     sum4 = 0;
      // }

      sum_product_data = [{
        'MMA': this.nearestValue(sum1, true), //sum1,
        'WGR': this.nearestValue(sum2, true),
        'FRU': sum3,
        'MLK': sum4,
        'VEG': sum5,
        'DG': sum6,
        'RO': sum7,
        'BPL': sum8,
        'STAR': sum9,
        'OTH': sum10,
        'CALS': this.roundTwoDecimals(sum11),
        'SOD': this.roundTwoDecimals(sum12),
        'FAT': this.roundTwoDecimals(sum13),
        'PROT': this.roundTwoDecimals(sum14),
        'CARB': this.roundTwoDecimals(sum15),
        'SUG': this.roundTwoDecimals(sum16),
        'nutrition_facts_satfat_percent': nutrition_facts_satfat_percent,
        'nutrition_facts_satfat': this.roundTwoDecimals(nutrition_facts_satfat),
        'cals_percent': cals_percent,
      }];
    }

    return sum_product_data;
  },


  getIngPreferProductComponentVal(ing_prefer_product, type) {
    let optional_type = 'optional_' + type;

    if (ing_prefer_product[optional_type] !== null && ing_prefer_product[optional_type] !== undefined) {
      return parseFloat(ing_prefer_product[optional_type]);
    } else {
      return parseFloat(ing_prefer_product[type]);

    }

  },

  getNutritionComponentScaleFactor(ing_product) {
    let ing_amount = ing_product.serving_amount;
    let ing_uom = ing_product.serving_amount_uom;

    let ing_uom_type = this.uomType(ing_uom);

    if (ing_amount === null) return 0;

    let base_amount = null;
    let base_uom = null;

    if (ing_uom_type == "Unit") {
      if (ing_product.preferred_product_information.nutrition_facts_unit !== null) {
        base_amount = ing_product.preferred_product_information.nutrition_facts_unit;
        base_uom = ing_product.preferred_product_information.nutrition_facts_unit_uom;
      }
    }

    if (ing_uom_type == "Weight") {

      if (ing_product.preferred_product_information.nutrition_facts_volume !== null) {
        base_amount = ing_product.preferred_product_information.nutrition_facts_volume;
        base_uom = ing_product.preferred_product_information.nutrition_facts_volume_uom;
      }

      if (ing_product.preferred_product_information.nutrition_facts_weight !== null) {
        base_amount = ing_product.preferred_product_information.nutrition_facts_weight;
        base_uom = ing_product.preferred_product_information.nutrition_facts_weight_uom;
      }
    }

    if (ing_uom_type == "Volume") {
      if (ing_product.preferred_product_information.nutrition_facts_weight !== null) {
        base_amount = ing_product.preferred_product_information.nutrition_facts_weight;
        base_uom = ing_product.preferred_product_information.nutrition_facts_weight_uom;
      }
      if (ing_product.preferred_product_information.nutrition_facts_volume !== null) {
        base_amount = ing_product.preferred_product_information.nutrition_facts_volume;
        base_uom = ing_product.preferred_product_information.nutrition_facts_volume_uom;
      }
    }


    const newUom = base_uom;
    const oldUom = ing_uom;

    const newUomType = this.uomType(newUom);
    const oldUomType = this.uomType(oldUom);

    const initAmount = ing_amount;
    let newAmount = null;

    if (newUomType === oldUomType && newUomType === 'Weight') {
      newAmount = conversions.weight(initAmount, oldUom, newUom);
    }

    if (newUomType === oldUomType && newUomType === 'Volume') {
      newAmount = conversions.volume(initAmount, oldUom, newUom);
    }

    if (newUomType === 'Weight' && oldUomType === 'Volume') {
      newAmount = conversions.volumeToWeight(ing_product.preferred_product_information, initAmount, oldUom, newUom)
    }

    if (newUomType === 'Volume' && oldUomType === 'Weight') {
      newAmount = conversions.weightToVolume(ing_product.preferred_product_information, initAmount, oldUom, newUom)
    }

    if (newUomType === oldUomType && newUomType === 'Unit') {
      newAmount = initAmount;
    }


    let scale_factor = newAmount / base_amount;

    // //// console.log('Nutrition_scale_factor', scale_factor);

    if (isFinite(scale_factor) && !isNaN(scale_factor) && scale_factor !== null) {
      return scale_factor;
    } else {
      return 0;
    }
  },


  getNutritionScaleFactor(ing_product) {
    let ing_amount = ing_product.serving_amount;
    let ing_uom = ing_product.serving_amount_uom;

    let ing_uom_type = this.uomType(ing_uom);
    if (ing_amount === null) return 0;

    let base_amount = null;
    let base_uom = null;
    if (ing_uom_type == "Unit") {
      if (ing_product.preferred_product_information.nutrition_facts_unit !== null) {
        base_amount = ing_product.preferred_product_information.nutrition_facts_unit;
        base_uom = ing_product.preferred_product_information.nutrition_facts_unit_uom;
      }
    }

    if (ing_uom_type == "Weight") {

      if (ing_product.preferred_product_information.nutrition_facts_volume !== null) {
        base_amount = ing_product.preferred_product_information.nutrition_facts_volume;
        base_uom = ing_product.preferred_product_information.nutrition_facts_volume_uom;
      }

      if (ing_product.preferred_product_information.nutrition_facts_weight !== null) {
        base_amount = ing_product.preferred_product_information.nutrition_facts_weight;
        base_uom = ing_product.preferred_product_information.nutrition_facts_weight_uom;
      }
    }

    if (ing_uom_type == "Volume") {
      if (ing_product.preferred_product_information.nutrition_facts_weight !== null) {
        base_amount = ing_product.preferred_product_information.nutrition_facts_weight;
        base_uom = ing_product.preferred_product_information.nutrition_facts_weight_uom;
      }
      if (ing_product.preferred_product_information.nutrition_facts_volume !== null) {
        base_amount = ing_product.preferred_product_information.nutrition_facts_volume;
        base_uom = ing_product.preferred_product_information.nutrition_facts_volume_uom;
      }
    }

    if (ing_uom_type === 'Custom') {
      // console.log("ing_product.serving_amount_uom", ing_product, ing_product.serving_amount_custom_uom);
      ing_uom = ing_product.serving_amount_custom_uom;
      if (this.uomType(ing_product.serving_amount_custom_uom) == 'Unit') {

        if (ing_product.preferred_product_information.nutrition_facts_unit !== null) {
          base_amount = ing_product.preferred_product_information.nutrition_facts_unit;
          base_uom = ing_product.preferred_product_information.nutrition_facts_unit_uom;
        }
      }

      if (this.uomType(ing_product.serving_amount_custom_uom) == 'Weight') {
        if (ing_product.preferred_product_information.nutrition_facts_volume !== null) {
          base_amount = ing_product.preferred_product_information.nutrition_facts_volume;
          base_uom = ing_product.preferred_product_information.nutrition_facts_volume_uom;
        }

        if (ing_product.preferred_product_information.nutrition_facts_weight !== null) {
          base_amount = ing_product.preferred_product_information.nutrition_facts_weight;
          base_uom = ing_product.preferred_product_information.nutrition_facts_weight_uom;
        }
      }

      if (this.uomType(ing_product.serving_amount_custom_uom) == 'Volume') {
        if (ing_product.preferred_product_information.nutrition_facts_weight !== null) {
          base_amount = ing_product.preferred_product_information.nutrition_facts_weight;
          base_uom = ing_product.preferred_product_information.nutrition_facts_weight_uom;
        }
        // if (ing_product.preferred_product_information.nutrition_facts_volume !== null) {
        //     base_amount = ing_product.preferred_product_information.nutrition_facts_volume;
        //     base_uom = ing_product.preferred_product_information.nutrition_facts_volume_uom;
        // }
      }
    }




    const newUom = base_uom;
    const oldUom = ing_uom;

    const newUomType = this.uomType(newUom);
    const oldUomType = this.uomType(oldUom);
    const initAmount = ing_amount;
    let newAmount = null;

    // console.log("getNutritionScaleFactor newUomType oldUomType", newUomType, oldUomType)


    if (newUomType === oldUomType && newUomType === 'Weight') {
      newAmount = conversions.weight(initAmount, oldUom, newUom);
    }

    if (newUomType === oldUomType && newUomType === 'Volume') {
      newAmount = conversions.volume(initAmount, oldUom, newUom);
    }

    if (newUomType === 'Weight' && oldUomType === 'Volume') {
      newAmount = conversions.volumeToWeight(ing_product.preferred_product_information, initAmount, oldUom, newUom)
    }

    if (newUomType === 'Volume' && oldUomType === 'Weight') {
      newAmount = conversions.weightToVolume(ing_product.preferred_product_information, initAmount, oldUom, newUom)
    }

    if (newUomType === oldUomType && newUomType === 'Unit') {
      newAmount = initAmount;
    }

    //// console.log("getNutritionScaleFactor", ing_amount, ing_uom_type);
    // new logic for hide
    if (ing_uom_type === 'Custom') {

      // console.log("preferProductsCalculatedTotals custom", ing_product.preferred_product_information.cuom);
      if (ing_product.preferred_product_information.cuom && ing_product.preferred_product_information.cuom.length > 0) {

        for (let i = 0; i < ing_product.preferred_product_information.cuom.length; i++) {
          // //// console.log("getNutritionScaleFactor in ", ing_product.preferred_product_information.cuom[i].description, ing_product.serving_amount_uom);

          if (ing_product.preferred_product_information.cuom[i].description1 == ing_product.serving_amount_uom) {
            // // console.log("getNutritionScaleFactor true ");
            newAmount = ing_product.serving_amount;
            let cuom = ing_product.preferred_product_information.cuom[i];
            if (this.uomType(ing_product.serving_amount_custom_uom) === 'Weight') {

              let baseAmount = ing_product.preferred_product_information.nutrition_facts_weight;
              let baseAmountUoM = ing_product.preferred_product_information.nutrition_facts_weight_uom;
              let convertedAmount = conversions.weight(baseAmount, baseAmountUoM, cuom.weight_units);
              let baseAmountScale = convertedAmount / cuom.weight;

              base_amount = cuom.weight * baseAmountScale;
              base_amount = conversions.weight(base_amount, cuom.weight_units, ing_product.serving_amount_custom_uom);
              // convertedAmount = base_amount;
            } else if (this.uomType(ing_product.serving_amount_custom_uom) === 'Volume') {
              let baseAmount = ing_product.preferred_product_information.nutrition_facts_weight;
              let baseAmountUoM = ing_product.preferred_product_information.nutrition_facts_weight_uom;
              let convertedAmount = conversions.weight(baseAmount, baseAmountUoM, cuom.weight_units);
              let baseAmountScale = convertedAmount / cuom.weight;

              base_amount = cuom.unit_amount * baseAmountScale;
              base_amount = conversions.volume(base_amount, cuom.unit_type, ing_product.serving_amount_custom_uom);

            } else if (this.uomType(ing_product.serving_amount_custom_uom) === 'Unit') {
              let baseAmount = ing_product.preferred_product_information.nutrition_facts_weight;
              let baseAmountUoM = ing_product.preferred_product_information.nutrition_facts_weight_uom;
              let convertedAmount = conversions.weight(baseAmount, baseAmountUoM, cuom.weight_units);
              let baseAmountScale = convertedAmount / cuom.weight;


              base_amount = cuom.unit_amount * baseAmountScale;
              // base_amount = base_amount;
            }

            // // console.log("getNutritionScaleFactor true ", base_amount, newAmount);

            // let baseAmount = ing_product.preferred_product_information.nutrition_facts_weight;
            // let baseAmountUoM = ing_product.preferred_product_information.nutrition_facts_weight_uom;
            // let convertedAmount = conversions.weight(baseAmount, baseAmountUoM, ing_product.preferred_product_information.cuom[i].weight_units);

            // convertedAmount = convertedAmount / (ing_product.preferred_product_information.cuom[i].weight / ing_product.preferred_product_information.cuom[i].unit_amount);
            // // //// console.log("Custom if helper", convertedAmount);
            // base_amount = convertedAmount;
            // newAmount = ing_product.serving_amount;
          }
        }
      }
    }


    // // console.log("getNutritionScaleFactor ", newAmount, base_amount);
    let scale_factor = newAmount / base_amount;

    // console.log('getNutritionScaleFactor scale_factor', scale_factor, newAmount, base_amount);

    if (isFinite(scale_factor) && !isNaN(scale_factor) && scale_factor !== null) {
      return scale_factor;
    } else {
      return 0;
    }

  },

  /****************************** Menu Week ************************************/

  // week/menu cycle avg calculated weekly totals...


  avg_products_week_setup(avg_ing_prefer_products) {

    let sum_final_products_weekly = [];
    let scale_val = 1;

    let sum1 = 0, sum2 = 0, sum3 = 0, sum4 = 0, sum5 = 0, sum6 = 0, sum7 = 0, sum8 = 0, sum9 = 0, sum10 = 0,
      sum11 = 0, sum12 = 0, sum13 = 0, sum14 = 0, sum15 = 0, final_total = 0;

    for (let one = 0; one < avg_ing_prefer_products.length; one++) {

      for (let two = 0; two < avg_ing_prefer_products[one].length; two++) {

        let ing_prefer_products = avg_ing_prefer_products[one][two];

        if (ing_prefer_products && ing_prefer_products.length > 0) {

          for (let i = 0; i < ing_prefer_products.length; i++) {

            scale_val = this.getMenuClycleNutritionScaleFactor(ing_prefer_products[i]);

            sum1 += parseFloat(ing_prefer_products[i]['usda_componenent_serving_meat']) || 0;
            sum2 += parseFloat(ing_prefer_products[i]['usda_componenent_serving_grain']) || 0;
            sum3 += parseFloat(ing_prefer_products[i]['usda_componenent_serving_fruit']) || 0;
            sum4 += parseFloat(ing_prefer_products[i]['usda_componenent_serving_milk']) || 0;
            sum5 += parseFloat(ing_prefer_products[i]['usda_componenent_serving_veg']) || 0;
            sum6 += parseFloat(ing_prefer_products[i]['usda_componenent_serving_veggrn']) || 0;
            sum7 += parseFloat(ing_prefer_products[i]['usda_componenent_serving_vegred']) || 0;
            sum8 += parseFloat(ing_prefer_products[i]['usda_componenent_serving_vegleg']) || 0;
            sum9 += parseFloat(ing_prefer_products[i]['usda_componenent_serving_vegstar']) || 0;
            sum10 += parseFloat(ing_prefer_products[i]['usda_componenent_serving_vegothr']) || 0;

            // sum11 += parseFloat(ing_prefer_products[i]['nutrition_facts_calories']) || 0;
            // sum12 += parseFloat(ing_prefer_products[i]['nutrition_facts_sodium']) || 0;
            // sum13 += parseFloat(ing_prefer_products[i]['nutrition_facts_totalfat']) || 0;
            // sum14 += parseFloat(ing_prefer_products[i]['nutrition_facts_protein']) || 0;
            // sum15 += parseFloat(ing_prefer_products[i]['nutrition_facts_carbs']) || 0;

            sum11 += parseFloat(ing_prefer_products[i]['nutrition_facts_calories']) * scale_val || 0;
            sum12 += parseFloat(ing_prefer_products[i]['nutrition_facts_sodium']) * scale_val || 0;
            sum13 += parseFloat(ing_prefer_products[i]['nutrition_facts_totalfat']) * scale_val || 0;
            sum14 += parseFloat(ing_prefer_products[i]['nutrition_facts_protein']) * scale_val || 0;
            sum15 += parseFloat(ing_prefer_products[i]['nutrition_facts_carbs']) * scale_val || 0;

          }


        }
      }
    }

    sum_final_products_weekly = [{
      'MMA': this.roundTwoDecimals(sum1),
      'WGR': this.roundTwoDecimals(sum2),
      'FRU': this.roundTwoDecimals(sum3),
      'MLK': this.roundTwoDecimals(sum4),
      'VEG': this.roundTwoDecimals(sum5),
      'DG': this.roundTwoDecimals(sum6),
      'RO': this.roundTwoDecimals(sum7),
      'BPL': this.roundTwoDecimals(sum8),
      'STAR': this.roundTwoDecimals(sum9),
      'OTH': this.roundTwoDecimals(sum10),
      'CALS': this.roundTwoDecimals(sum11, 'cals'),
      'SOD': this.roundTwoDecimals(sum12, 'mg'),
      'FAT': this.roundTwoDecimals(sum13, 'g'),
      'PROT': this.roundTwoDecimals(sum14, 'g'),
      'CARB': this.roundTwoDecimals(sum15, 'g'),
    }];

    ////// console.log(sum_final_products_weekly);
    return sum_final_products_weekly;


  },

  // week/menu cycle sum calculated daily totals...

  sum_products_daily_setup(ing_prefer_products) {
    ////// console.log('---',ing_prefer_products);
    let sum_products_daily = [];

    if (ing_prefer_products.length > 0) {

      let sum1 = 0, sum2 = 0, sum3 = 0, sum4 = 0, sum5 = 0, sum6 = 0, sum7 = 0, sum8 = 0, sum9 = 0, sum10 = 0,
        sum11 = 0, sum12 = 0, sum13 = 0, sum14 = 0, sum15 = 0;

      for (let index = 0; index < ing_prefer_products.length; index++) {

        let total_num = ing_prefer_products[index]?.length || 0;

        if (total_num > 0) {

          for (let i = 0; i < total_num; i++) {

            sum1 += parseFloat(ing_prefer_products[index][i]['usda_componenent_serving_meat']) || 0
            sum2 += parseFloat(ing_prefer_products[index][i]['usda_componenent_serving_grain']) || 0
            sum3 += parseFloat(ing_prefer_products[index][i]['usda_componenent_serving_fruit']) || 0
            sum4 += parseFloat(ing_prefer_products[index][i]['usda_componenent_serving_milk']) || 0
            sum5 += parseFloat(ing_prefer_products[index][i]['usda_componenent_serving_veg']) || 0
            sum6 += parseFloat(ing_prefer_products[index][i]['usda_componenent_serving_veggrn']) || 0
            sum7 += parseFloat(ing_prefer_products[index][i]['usda_componenent_serving_vegred']) || 0
            sum8 += parseFloat(ing_prefer_products[index][i]['usda_componenent_serving_vegleg']) || 0
            sum9 += parseFloat(ing_prefer_products[index][i]['usda_componenent_serving_vegstar']) || 0
            sum10 += parseFloat(ing_prefer_products[index][i]['usda_componenent_serving_vegothr']) || 0

          }

        }
      }

      sum_products_daily = [{
        'MMA': this.roundTwoDecimals(sum1),
        'WGR': this.roundTwoDecimals(sum2),
        'FRU': this.roundTwoDecimals(sum3),
        'MLK': this.roundTwoDecimals(sum4),
        'VEG': this.roundTwoDecimals(sum5),
        'DG': this.roundTwoDecimals(sum6),
        'RO': this.roundTwoDecimals(sum7),
        'BPL': this.roundTwoDecimals(sum8),
        'STAR': this.roundTwoDecimals(sum9),
        'OTH': this.roundTwoDecimals(sum10),
      }];

    }

    console.log('sum_products_daily', sum_products_daily);

    return sum_products_daily;
  },


  sum_products_week_popup_totals(ing_prefer_productss) {
    let avg_products = [];

    let total_num = ing_prefer_productss.length;
    let scale_val = 1;

    if (total_num > 0) {

      let sum1 = 0, sum2 = 0, sum3 = 0, sum4 = 0, sum5 = 0, sum6 = 0, sum7 = 0, sum8 = 0, sum9 = 0, sum10 = 0,
        sum11 = 0, sum12 = 0, sum13 = 0, sum14 = 0, sum15 = 0;

      for (let i = 0; i < total_num; i++) {

        scale_val = this.getMenuClycleNutritionScaleFactor(ing_prefer_productss[i]);

        sum1 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_meat']) || 0;
        sum2 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_grain']) || 0;
        sum3 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_fruit']) || 0;
        sum4 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_milk']) || 0;
        sum5 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_veg']) || 0;
        sum6 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_veggrn']) || 0;
        sum7 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_vegred']) || 0;
        sum8 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_vegleg']) || 0;
        sum9 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_vegstar']) || 0;
        sum10 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_vegothr']) || 0;

        sum11 += parseFloat(ing_prefer_productss[i]['nutrition_facts_calories']) * scale_val || 0;
        sum12 += parseFloat(ing_prefer_productss[i]['nutrition_facts_sodium']) * scale_val || 0;
        sum13 += parseFloat(ing_prefer_productss[i]['nutrition_facts_totalfat']) * scale_val || 0;
        sum14 += parseFloat(ing_prefer_productss[i]['nutrition_facts_protein']) * scale_val || 0;
        sum15 += parseFloat(ing_prefer_productss[i]['nutrition_facts_carbs']) * scale_val || 0;

      }

      avg_products = [{
        'MMA': this.roundTwoDecimals(sum1),
        'WGR': this.roundTwoDecimals(sum2),
        'FRU': this.roundTwoDecimals(sum3),
        'MLK': this.roundTwoDecimals(sum4),
        'VEG': this.roundTwoDecimals(sum5),
        'DG': this.roundTwoDecimals(sum6),
        'RO': this.roundTwoDecimals(sum7),
        'BPL': this.roundTwoDecimals(sum8),
        'STAR': this.roundTwoDecimals(sum9),
        'OTH': this.roundTwoDecimals(sum10),
        'CALS': this.roundTwoDecimals(sum11, 'cals'),
        'SOD': this.roundTwoDecimals(sum12, 'mg'),
        'FAT': this.roundTwoDecimals(sum13, 'g'),
        'PROT': this.roundTwoDecimals(sum14, 'g'),
        'CARB': this.roundTwoDecimals(sum15, 'g'),
      }];
    }
    return avg_products;
  },

  sum_products_week_popup_totals_new(ing_prefer_productss) {
    let avg_products = {};
    let total_num = ing_prefer_productss.length;
    let scale_val = 1;

    if (total_num > 0) {

      let sum1 = 0, sum2 = 0, sum3 = 0, sum4 = 0, sum5 = 0, sum6 = 0, sum7 = 0, sum8 = 0, sum9 = 0, sum10 = 0,
        sum11 = 0, sum12 = 0, sum13 = 0, sum14 = 0, sum15 = 0;

      let calfat = 0, satfat = 0, transfat = 0, polysatfat = 0, monosatfat = 0, cholesterol = 0, potassium = 0,
        fiber = 0, sugar = 0, vitamina = 0, vitaminb6 = 0, vitaminb12 = 0, vitaminc = 0, vitamind = 0,
        vitamine = 0, calcium = 0, iron = 0, magnesium = 0, coblamin = 0, thiamin = 0, riboflavin = 0,
        niacin = 0, zinc = 0, water = 0, ash = 0, added_sugars = 0;


      for (let i = 0; i < total_num; i++) {

        scale_val = this.getMenuClycleNutritionScaleFactor(ing_prefer_productss[i]);
        // // console.log('attached_recipes scale_val', scale_val);
        sum1 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_meat']) || 0;
        sum2 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_grain']) || 0;
        sum3 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_fruit']) || 0;
        sum4 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_milk']) || 0;
        sum5 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_veg']) || 0;
        sum6 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_veggrn']) || 0;
        sum7 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_vegred']) || 0;
        sum8 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_vegleg']) || 0;
        sum9 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_vegstar']) || 0;
        sum10 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_vegothr']) || 0;

        sum11 += parseFloat(ing_prefer_productss[i]['nutrition_facts_calories']) * scale_val || 0;
        sum12 += parseFloat(ing_prefer_productss[i]['nutrition_facts_sodium']) * scale_val || 0;
        sum13 += parseFloat(ing_prefer_productss[i]['nutrition_facts_totalfat']) * scale_val || 0;
        sum14 += parseFloat(ing_prefer_productss[i]['nutrition_facts_protein']) * scale_val || 0;
        sum15 += parseFloat(ing_prefer_productss[i]['nutrition_facts_carbs']) * scale_val || 0;

        calfat += parseFloat(ing_prefer_productss[i]['nutrition_facts_calfat']) * scale_val || 0;
        satfat += parseFloat(ing_prefer_productss[i]['nutrition_facts_satfat']) * scale_val || 0;
        transfat += parseFloat(ing_prefer_productss[i]['nutrition_facts_transfat']) * scale_val || 0;
        polysatfat += parseFloat(ing_prefer_productss[i]['nutrition_facts_polysatfat']) * scale_val || 0;
        monosatfat += parseFloat(ing_prefer_productss[i]['nutrition_facts_monosatfat']) * scale_val || 0;
        cholesterol += parseFloat(ing_prefer_productss[i]['nutrition_facts_cholesterol']) * scale_val || 0;
        potassium += parseFloat(ing_prefer_productss[i]['nutrition_facts_potassium']) * scale_val || 0;
        fiber += parseFloat(ing_prefer_productss[i]['nutrition_facts_fiber']) * scale_val || 0;
        sugar += parseFloat(ing_prefer_productss[i]['nutrition_facts_sugar']) * scale_val || 0;
        vitamina += parseFloat(ing_prefer_productss[i]['nutrition_facts_vitamina']) * scale_val || 0;
        vitaminb6 += parseFloat(ing_prefer_productss[i]['nutrition_facts_vitaminb6']) * scale_val || 0;
        vitaminb12 += parseFloat(ing_prefer_productss[i]['nutrition_facts_vitaminb12']) * scale_val || 0;
        vitaminc += parseFloat(ing_prefer_productss[i]['nutrition_facts_vitaminc']) * scale_val || 0;
        vitamind += parseFloat(ing_prefer_productss[i]['nutrition_facts_vitamind']) * scale_val || 0;
        vitamine += parseFloat(ing_prefer_productss[i]['nutrition_facts_vitamine']) * scale_val || 0;
        calcium += parseFloat(ing_prefer_productss[i]['nutrition_facts_calcium']) * scale_val || 0;
        iron += parseFloat(ing_prefer_productss[i]['nutrition_facts_iron']) * scale_val || 0;
        magnesium += parseFloat(ing_prefer_productss[i]['nutrition_facts_magnesium']) * scale_val || 0;
        coblamin += parseFloat(ing_prefer_productss[i]['nutrition_facts_coblamin']) * scale_val || 0;
        thiamin += parseFloat(ing_prefer_productss[i]['nutrition_facts_thiamin']) * scale_val || 0;
        riboflavin += parseFloat(ing_prefer_productss[i]['nutrition_facts_riboflavin']) * scale_val || 0;
        niacin += parseFloat(ing_prefer_productss[i]['nutrition_facts_niacin']) * scale_val || 0;
        zinc += parseFloat(ing_prefer_productss[i]['nutrition_facts_zinc']) * scale_val || 0;
        water += parseFloat(ing_prefer_productss[i]['nutrition_facts_water']) * scale_val || 0;
        ash += parseFloat(ing_prefer_productss[i]['nutrition_facts_ash']) * scale_val || 0;
        added_sugars += parseFloat(ing_prefer_productss[i]['nutrition_facts_added_sugars']) * scale_val || 0;


      }

      // console.error("check cals sum11", sum11, scale_val);

      avg_products = {
        'MMA': this.nearestValue(sum1, true),
        'WGR': this.nearestValue(sum2, true),
        'FRU': this.nearestValue(sum3),
        'MLK': this.nearestValue(sum4),
        'VEG': this.nearestValue(sum5),
        'DG': this.nearestValue(sum6),
        'RO': this.nearestValue(sum7),
        'BPL': this.nearestValue(sum8),
        'STAR': this.nearestValue(sum9),
        'OTH': this.nearestValue(sum10),
        'CALS': this.nearestValue(sum11),
        'SOD': this.roundToThousandths(sum12),
        'FAT': this.roundToThousandths(sum13),
        'PROT': this.roundToThousandths(sum14),
        'CARB': this.roundToThousandths(sum15),

        'calfat': this.roundToThousandths(calfat),
        'satfat': this.roundToThousandths(satfat),
        'transfat': this.roundToThousandths(transfat),
        'polysatfat': this.roundToThousandths(polysatfat),
        'monosatfat': this.roundToThousandths(monosatfat),
        'cholesterol': this.roundToThousandths(cholesterol),
        'potassium': this.roundToThousandths(potassium),
        'fiber': this.roundToThousandths(fiber),
        'sugar': this.roundToThousandths(sugar),
        'vitamina': this.roundToThousandths(vitamina),
        'vitaminb6': this.roundToThousandths(vitaminb6),
        'vitaminb12': this.roundToThousandths(vitaminb12),
        'vitaminc': this.roundToThousandths(vitaminc),
        'vitamind': this.roundToThousandths(vitamind),
        'vitamine': this.roundToThousandths(vitamine),
        'calcium': this.roundToThousandths(calcium),
        'iron': this.roundToThousandths(iron),
        'magnesium': this.roundToThousandths(magnesium),
        'coblamin': this.roundToThousandths(coblamin),
        'thiamin': this.roundToThousandths(thiamin),
        'riboflavin': this.roundToThousandths(riboflavin),
        'niacin': this.roundToThousandths(niacin),
        'zinc': this.roundToThousandths(zinc),
        'water': this.roundToThousandths(water),
        'ash': this.roundToThousandths(ash),
        'added_sugars': this.roundToThousandths(added_sugars),
      };
    }
    // // console.log('avg_products', avg_products);
    // // console.log('avg_products ing_prefer_productss', ing_prefer_productss);
    return avg_products;
  },

  sum_products_week_popup_totals_new_override(ing_prefer_productss, recipe) {
    // console.log('calculation_total_override', recipe);
    let avg_products = {};
    let total_num = ing_prefer_productss.length;
    let scale_val = 1;

    if (total_num > 0) {

      let sum1 = 0, sum2 = 0, sum3 = 0, sum4 = 0, sum5 = 0, sum6 = 0, sum7 = 0, sum8 = 0, sum9 = 0, sum10 = 0,
        sum11 = 0, sum12 = 0, sum13 = 0, sum14 = 0, sum15 = 0;

      let calfat = 0, satfat = 0, transfat = 0, polysatfat = 0, monosatfat = 0, cholesterol = 0, potassium = 0,
        fiber = 0, sugar = 0, vitamina = 0, vitaminb6 = 0, vitaminb12 = 0, vitaminc = 0, vitamind = 0,
        vitamine = 0, calcium = 0, iron = 0, magnesium = 0, coblamin = 0, thiamin = 0, riboflavin = 0,
        niacin = 0, zinc = 0, water = 0, ash = 0, added_sugars = 0;

      let override_is_fruit_juice = 0,
        override_is_veg_juice = 0,
        override_is_the_milk_flavored = 0,
        override_milk_fat_content = 0,
        override_is_milk = 0,
        override_is_whole_grains_info = 0,
        override_is_whole_grains_dessert = 0;


      for (let i = 0; i < total_num; i++) {



        scale_val = this.getMenuClycleNutritionScaleFactor(ing_prefer_productss[i]);
        // // console.log('attached_recipes scale_val', scale_val);
        sum1 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_meat']) || 0;
        sum2 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_grain']) || 0;
        sum3 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_fruit']) || 0;

        sum4 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_milk']) || 0;
        sum5 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_veg']) || 0;
        sum6 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_veggrn']) || 0;
        sum7 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_vegred']) || 0;
        sum8 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_vegleg']) || 0;
        sum9 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_vegstar']) || 0;
        sum10 += parseFloat(ing_prefer_productss[i]['usda_componenent_serving_vegothr']) || 0;

        sum11 += parseFloat(ing_prefer_productss[i]['nutrition_facts_calories']) * scale_val || 0;
        sum12 += parseFloat(ing_prefer_productss[i]['nutrition_facts_sodium']) * scale_val || 0;
        sum13 += parseFloat(ing_prefer_productss[i]['nutrition_facts_totalfat']) * scale_val || 0;
        sum14 += parseFloat(ing_prefer_productss[i]['nutrition_facts_protein']) * scale_val || 0;
        sum15 += parseFloat(ing_prefer_productss[i]['nutrition_facts_carbs']) * scale_val || 0;

        calfat += parseFloat(ing_prefer_productss[i]['nutrition_facts_calfat']) * scale_val || 0;
        satfat += parseFloat(ing_prefer_productss[i]['nutrition_facts_satfat']) * scale_val || 0;
        transfat += parseFloat(ing_prefer_productss[i]['nutrition_facts_transfat']) * scale_val || 0;
        polysatfat += parseFloat(ing_prefer_productss[i]['nutrition_facts_polysatfat']) * scale_val || 0;
        monosatfat += parseFloat(ing_prefer_productss[i]['nutrition_facts_monosatfat']) * scale_val || 0;
        cholesterol += parseFloat(ing_prefer_productss[i]['nutrition_facts_cholesterol']) * scale_val || 0;
        potassium += parseFloat(ing_prefer_productss[i]['nutrition_facts_potassium']) * scale_val || 0;
        fiber += parseFloat(ing_prefer_productss[i]['nutrition_facts_fiber']) * scale_val || 0;
        sugar += parseFloat(ing_prefer_productss[i]['nutrition_facts_sugar']) * scale_val || 0;
        vitamina += parseFloat(ing_prefer_productss[i]['nutrition_facts_vitamina']) * scale_val || 0;
        vitaminb6 += parseFloat(ing_prefer_productss[i]['nutrition_facts_vitaminb6']) * scale_val || 0;
        vitaminb12 += parseFloat(ing_prefer_productss[i]['nutrition_facts_vitaminb12']) * scale_val || 0;
        vitaminc += parseFloat(ing_prefer_productss[i]['nutrition_facts_vitaminc']) * scale_val || 0;
        vitamind += parseFloat(ing_prefer_productss[i]['nutrition_facts_vitamind']) * scale_val || 0;
        vitamine += parseFloat(ing_prefer_productss[i]['nutrition_facts_vitamine']) * scale_val || 0;
        calcium += parseFloat(ing_prefer_productss[i]['nutrition_facts_calcium']) * scale_val || 0;
        iron += parseFloat(ing_prefer_productss[i]['nutrition_facts_iron']) * scale_val || 0;
        magnesium += parseFloat(ing_prefer_productss[i]['nutrition_facts_magnesium']) * scale_val || 0;
        coblamin += parseFloat(ing_prefer_productss[i]['nutrition_facts_coblamin']) * scale_val || 0;
        thiamin += parseFloat(ing_prefer_productss[i]['nutrition_facts_thiamin']) * scale_val || 0;
        riboflavin += parseFloat(ing_prefer_productss[i]['nutrition_facts_riboflavin']) * scale_val || 0;
        niacin += parseFloat(ing_prefer_productss[i]['nutrition_facts_niacin']) * scale_val || 0;
        zinc += parseFloat(ing_prefer_productss[i]['nutrition_facts_zinc']) * scale_val || 0;
        water += parseFloat(ing_prefer_productss[i]['nutrition_facts_water']) * scale_val || 0;
        ash += parseFloat(ing_prefer_productss[i]['nutrition_facts_ash']) * scale_val || 0;
        added_sugars += parseFloat(ing_prefer_productss[i]['nutrition_facts_added_sugars']) * scale_val || 0;


        // Juice
        if (ing_prefer_productss[i].is_the_product_juice == 'Yes') {
          if (sum3 > 0) {
            override_is_fruit_juice = 1;
          }
          if (sum5 > 0) {
            override_is_veg_juice = 1;
          }
        }

        // Milk
        if (sum4 > 0) {
          override_is_milk = 1;
          if (ing_prefer_productss[i].is_the_milk_flavored == 'Yes') {
            override_is_the_milk_flavored = 1;
          }

          if (['Whole Milk', 'Reduced Fat 2%', 'Low Fat 1%', 'Fat-Free / Skim'].includes(ing_prefer_productss[i].milk_fat_content)) {
            override_milk_fat_content = ing_prefer_productss[i].milk_fat_content;
          }
        }

        // Grain
        if (sum2 > 0) {
          if (ing_prefer_productss[i].is_whole_grains_info == 'Yes') {
            override_is_whole_grains_info = 1;
          }
          if (ing_prefer_productss[i].is_whole_grains_dessert == 'Yes') {
            override_is_whole_grains_dessert = 1;
          }
        }

      }

      // console.error("check cals sum11", sum11, scale_val);

      avg_products = {
        'MMA': this.nearestValue(sum1, true),
        'WGR': this.nearestValue(sum2, true),
        'FRU': this.nearestValue(sum3),
        'MLK': this.nearestValue(sum4),
        'VEG': this.nearestValue(sum5),
        'DG': this.nearestValue(sum6),
        'RO': this.nearestValue(sum7),
        'BPL': this.nearestValue(sum8),
        'STAR': this.nearestValue(sum9),
        'OTH': this.nearestValue(sum10),
        'CALS': this.nearestValue(sum11),
        'SOD': this.roundToThousandths(sum12),
        'FAT': this.roundToThousandths(sum13),
        'PROT': this.roundToThousandths(sum14),
        'CARB': this.roundToThousandths(sum15),

        'calfat': this.roundToThousandths(calfat),
        'satfat': this.roundToThousandths(satfat),
        'transfat': this.roundToThousandths(transfat),
        'polysatfat': this.roundToThousandths(polysatfat),
        'monosatfat': this.roundToThousandths(monosatfat),
        'cholesterol': this.roundToThousandths(cholesterol),
        'potassium': this.roundToThousandths(potassium),
        'fiber': this.roundToThousandths(fiber),
        'sugar': this.roundToThousandths(sugar),
        'vitamina': this.roundToThousandths(vitamina),
        'vitaminb6': this.roundToThousandths(vitaminb6),
        'vitaminb12': this.roundToThousandths(vitaminb12),
        'vitaminc': this.roundToThousandths(vitaminc),
        'vitamind': this.roundToThousandths(vitamind),
        'vitamine': this.roundToThousandths(vitamine),
        'calcium': this.roundToThousandths(calcium),
        'iron': this.roundToThousandths(iron),
        'magnesium': this.roundToThousandths(magnesium),
        'coblamin': this.roundToThousandths(coblamin),
        'thiamin': this.roundToThousandths(thiamin),
        'riboflavin': this.roundToThousandths(riboflavin),
        'niacin': this.roundToThousandths(niacin),
        'zinc': this.roundToThousandths(zinc),
        'water': this.roundToThousandths(water),
        'ash': this.roundToThousandths(ash),
        'added_sugars': this.roundToThousandths(added_sugars),
        'override_is_fruit_juice': override_is_fruit_juice,
        'override_is_veg_juice': override_is_veg_juice,
        'override_is_the_milk_flavored': override_is_the_milk_flavored,
        'override_milk_fat_content': override_milk_fat_content,
        'override_is_milk': override_is_milk,
        'override_is_whole_grains_info': override_is_whole_grains_info,
        'override_is_whole_grains_dessert': override_is_whole_grains_dessert
      };

      // console.log('nav avg_products start', avg_products);

      if (recipe.is_calculation_total_override) {
        // console.log('recipe.calculation_total_override', recipe.calculation_total_override);
        for (const key in recipe.calculation_total_override) {
          if (recipe.calculation_total_override.hasOwnProperty(key)) {
            avg_products[key] = this.nearestValue(recipe.calculation_total_override[key]);
          }
          if (key === 'nutrition_facts_satfat') {
            avg_products['satfat'] = this.nearestValue(recipe.calculation_total_override[key]);
          }
          if (key === 'SUG') {
            avg_products['added_sugars'] = this.nearestValue(recipe.calculation_total_override[key]);
          }
        }

        // console.log('nav avg_products override total', avg_products);

        // Fruit Juice
        if (avg_products['FRU'] > 0) {
          if (['Yes', 'No'].includes(recipe.is_the_recipe_juice)) {
            avg_products['override_is_fruit_juice'] = Number(recipe.is_the_recipe_juice == 'Yes');
          }
        } else {
          avg_products['override_is_fruit_juice'] = 0;
        }

        // Vegetable Juice
        if (avg_products['VEG'] > 0) {
          if (['Yes', 'No'].includes(recipe.is_the_recipe_juice)) {
            avg_products['override_is_veg_juice'] = Number(recipe.is_the_recipe_juice == 'Yes');
          }
        } else {
          avg_products['override_is_veg_juice'] = 0;
        }

        // console.log('nav avg_products milk  ', avg_products.MLK );
        // console.log('nav avg_products milk ',  avg_products['MLK']);
        // The Milk Flavored
        if (avg_products['MLK'] > 0) {

          avg_products['override_is_milk'] = 1;
          if (['Yes', 'No'].includes(recipe.is_the_milk_flavored)) {
            avg_products['override_is_the_milk_flavored'] = Number(recipe.is_the_milk_flavored == 'Yes'); //recipe.is_the_recipe_milk_flavored == 'Yes';
          }

          if (['Whole Milk', 'Reduced Fat 2%', 'Low Fat 1%', 'Fat-Free / Skim'].includes(recipe.milk_fat_content)) {
            avg_products['override_milk_fat_content'] = recipe.milk_fat_content;
          }

          // console.log('nav avg_products milk end', avg_products);

        } else {
          avg_products['override_is_the_milk_flavored'] = 0;
          avg_products['override_milk_fat_content'] = 0;
        }

        if (avg_products['WGR'] > 0) {
          if (['Yes', 'No'].includes(recipe.is_whole_grains_info)) {
            avg_products['override_is_whole_grains_info'] = Number(recipe.is_whole_grains_info == 'Yes');
          }

          if (['Yes', 'No'].includes(recipe.is_whole_grains_dessert)) {
            avg_products['override_is_whole_grains_dessert'] = Number(recipe.is_whole_grains_dessert == 'Yes');
          }

        } else {
          avg_products['override_is_whole_grains_info'] = 0;
          avg_products['override_is_whole_grains_dessert'] = 0;
        }
      }
    }


    // avg_products['VEG'] = avg_products['DG'] + avg_products['RO'] + avg_products['BPL'] + avg_products['STAR'] + avg_products['OTH'];
    // // console.log('avg_products', avg_products);
    // // console.log('avg_products ing_prefer_productss', ing_prefer_productss);
    return avg_products;
  },

  roundTwoDecimalsNew(result, unit = null) {

    if (result == 0 || isNaN(result) || !isFinite(result)) {
      return result;
    } else {

      let string = result.toString();
      let array = string.split('.');
      let firstNumber = +array[0];
      let secondNumber = +array[1];
      let newEighthValue = secondNumber / 8;
      let nearestValue = '.' + newEighthValue * 7;
      let newValue = parseFloat(firstNumber) + parseFloat(nearestValue);

      // if(!isNaN(firstNumber) && !isNaN(secondNumber)){
      //   let reslt = +(newValue).toFixed(3);
      //   return reslt +unit;
      // }else{
      let reslt = +(result).toFixed(3);
      return reslt + unit;
      // }

    }
  },

  nutritionalRounds(vals) {
    return Math.round(vals);
  },
  MathOneDecimal(result) {
    if (result == 0 || isNaN(result) || !isFinite(result) || !result) {
      return result;
    } else {
      result = Number(result);
      return result.toFixed(1);
    }

  },


  nearestValue(result, oneFourth) {
    if (result == 0 || isNaN(result) || !isFinite(result) || !result) {
      return result;
    } else {
      // // console.log('nearestValue', typeof result, result, Math.floor(result * 8) / 8);
      if (oneFourth == true) {
        return Math.floor(result * 4) / 4;
      } else {
        return Math.floor(result * 8) / 8;
      }

    }
  },
  roundToThousandths(result) {
    // console.log('result', result);
    if (result == 0 || isNaN(result) || !isFinite(result) || !result) {
      return result;
    } else {
      // return Math.floor(result * 8) / 8;
      // return Math.floor(result * 1000) / 1000;
      // return Number(result.toFixed(3));
      // return Number(result.toFixed(3));

      let scaledValue = result * 10000;

      // console.log('scaledValue', scaledValue);
      // Separate the integer and fractional parts after scaling
      let integerPart = Math.floor(scaledValue / 10);
      let fourthDecimal = Math.floor(scaledValue % 10);

      // Apply rounding based on the fourth decimal digit
      if (fourthDecimal >= 5) {
        integerPart += 1; // Round up
      }
      return integerPart / 1000;
    }
  },

  minus_products_week_popup_totals(product_avg, ing_prefer_productss) {
    // //// console.log('ing_prefer_productss12434',ing_prefer_productss);
    // //// console.log('ing_prefer_productss124',ing_prefer_productss[0]);
    // //// console.log('ing_prefer_productss12',JSON.stringify(ing_prefer_productss));
    ing_prefer_productss.forEach((value, index) => {
      // //// console.log("ing_prefer_products_42343243",value);
    });

    let avg_products = [];

    let total_num = ing_prefer_productss.length;
    // //// console.log("total_num",total_num);
    let scale_val = 1;

    // if(total_num > 0)
    // {
    // //// console.log('product_avg.MMA',product_avg.MMA);
    let sum1 = product_avg.MMA, sum2 = product_avg.WGR, sum3 = product_avg.FRU, sum4 = product_avg.MLK,
      sum5 = product_avg.VEG, sum6 = product_avg.DG, sum7 = product_avg.RO, sum8 = product_avg.BPL,
      sum9 = product_avg.STAR, sum10 = product_avg.OTH, sum11 = product_avg.CALS, sum12 = product_avg.SOD,
      sum13 = product_avg.FAT, sum14 = product_avg.PROT, sum15 = product_avg.CARB;
    let i = 0;

    //for (let i = 0; i < total_num; i++) {

    //scale_val = this.getMenuClycleNutritionScaleFactor(ing_prefer_productss[i]);
    // sum1 -=  parseFloat(ing_prefer_productss[i]['usda_componenent_serving_meat']) || 0;
    // //// console.log('sum1',sum1);
    // sum2 -= parseFloat(ing_prefer_productss[i]['usda_componenent_serving_grain']) || 0;
    // sum3 -= parseFloat(ing_prefer_productss[i]['usda_componenent_serving_fruit']) || 0;
    // sum4 -= parseFloat(ing_prefer_productss[i]['usda_componenent_serving_milk']) || 0;
    // sum5 -= parseFloat(ing_prefer_productss[i]['usda_componenent_serving_veg']) || 0;
    // sum6 -= parseFloat(ing_prefer_productss[i]['usda_componenent_serving_veggrn']) || 0;
    // sum7 -= parseFloat(ing_prefer_productss[i]['usda_componenent_serving_vegred']) || 0;
    // sum8 -= parseFloat(ing_prefer_productss[i]['usda_componenent_serving_vegleg']) || 0;
    // sum9 -= parseFloat(ing_prefer_productss[i]['usda_componenent_serving_vegstar']) || 0;
    // sum10 -= parseFloat(ing_prefer_productss[i]['usda_componenent_serving_vegothr']) || 0;

    // sum11 -= parseFloat(ing_prefer_productss[i]['nutrition_facts_calories']) * scale_val || 0;
    // sum12 -= parseFloat(ing_prefer_productss[i]['nutrition_facts_sodium']) * scale_val || 0;
    // sum13 -= parseFloat(ing_prefer_productss[i]['nutrition_facts_totalfat']) * scale_val || 0;
    // sum14 -= parseFloat(ing_prefer_productss[i]['nutrition_facts_protein']) * scale_val || 0;
    // sum15 -= parseFloat(ing_prefer_productss[i]['nutrition_facts_carbs']) * scale_val || 0;

    //}

    avg_products = [{
      'MMA': this.roundTwoDecimals(sum1),
      'WGR': this.roundTwoDecimals(sum2),
      'FRU': this.roundTwoDecimals(sum3),
      'MLK': this.roundTwoDecimals(sum4),
      'VEG': this.roundTwoDecimals(sum5),
      'DG': this.roundTwoDecimals(sum6),
      'RO': this.roundTwoDecimals(sum7),
      'BPL': this.roundTwoDecimals(sum8),
      'STAR': this.roundTwoDecimals(sum9),
      'OTH': this.roundTwoDecimals(sum10),
      'CALS': this.roundTwoDecimals(sum11, 'cals'),
      'SOD': this.roundTwoDecimals(sum12, 'mg'),
      'FAT': this.roundTwoDecimals(sum13, 'g'),
      'PROT': this.roundTwoDecimals(sum14, 'g'),
      'CARB': this.roundTwoDecimals(sum15, 'g'),
    }];
    //}
    // //// console.log('min_avg_products',avg_products);
    return avg_products;
  },


  roundTwoDecimals(result, unit = null) {

    if (result == 0 || isNaN(result) || !isFinite(result)) {
      return ' - ';
    } else {
      let reslt = +(result).toFixed(3);
      return reslt + unit;
    }
  },


  getMenuClycleNutritionScaleFactor(ing_product) {
    // console.error('getMenuClycleNutritionScaleFactor');
    // console.log('attached_recipes ing_product', ing_product);
    let ing_amount = ing_product.serving_amount;
    let ing_uom = ing_product.serving_amount_uom;
    let is_custom_uom = ing_product.is_custom_uom;
    let ing_uom_type = this.uomType(ing_uom);
    console.log('getMenuClycleNutritionScaleFactor', ing_product);
    // // console.log('attached_recipes ing_uom_type', ing_uom_type);

    //  // console.log('getMenuClycleNutritionScaleFactor', 'ing_product', ing_product,  "ing_amount", ing_amount, 'ing_uom', ing_uom, 'ing_uom_type', ing_uom_type);

    if (ing_amount === null) return 0;

    //   // console.log('getMenuClycleNutritionScaleFactor in', "ing_amount", ing_amount, 'ing_uom', ing_uom, 'ing_uom_type', ing_uom_type);

    /////////get scale factor

    let baseAmount = null
    let baseAmountUoM = null
    let convertedAmount = null
    if (!is_custom_uom) {
      if (ing_uom_type === 'Weight') {
        baseAmount = ing_product.nutrition_facts_weight;
        baseAmountUoM = ing_product.nutrition_facts_weight_uom_name;
        convertedAmount = conversions.weight(baseAmount, baseAmountUoM, ing_uom);
      }

      if (ing_uom_type === 'Volume') {
        baseAmount = ing_product.nutrition_facts_volume;
        baseAmountUoM = ing_product.nutrition_facts_volume_uom_name;
        convertedAmount = conversions.volume(baseAmount, baseAmountUoM, ing_uom);
      }

      if (ing_uom_type === 'Unit') {
        baseAmount = ing_product.nutrition_facts_unit;
        convertedAmount = baseAmount;
      }
    }

    //   custom unit of measurement
    // new logic
    if (is_custom_uom) {
      if (this.uomType(ing_product.serving_amount_custom_uom) === 'Weight' && ing_product.custom_uom_base_values) {
        baseAmount = ing_product.nutrition_facts_weight;
        baseAmountUoM = ing_product.nutrition_facts_weight_uom_name;
        convertedAmount = conversions.weight(baseAmount, baseAmountUoM, ing_product.serving_amount_custom_uom);
        // old logic
        // baseAmount = ing_product.custom_uom_base_values.weight;
        // baseAmountUoM = ing_product.custom_uom_base_values.weight_units;
        // convertedAmount = conversions.weight(baseAmount, baseAmountUoM, ing_product.serving_amount_custom_uom);
      }
      if (this.uomType(ing_product.serving_amount_custom_uom) === 'Volume' && ing_product.custom_uom_base_values) {
        // // console.log('attached_recipes ing_product', ing_product);

        let baseAmount = ing_product.nutrition_facts_weight;
        let baseAmountUoM = ing_product.nutrition_facts_weight_uom_name;
        convertedAmount = conversions.weight(baseAmount, baseAmountUoM, ing_product.custom_uom_base_values.weight_units);

        let baseAmountScale = convertedAmount / ing_product.custom_uom_base_values.weight;

        // // console.log("convertedAmount volume first ", baseAmount, baseAmountUoM, convertedAmount, baseAmountScale);

        // new logic
        // baseAmount = ing_product.nutrition_facts_volume;
        // baseAmountUoM = ing_product.nutrition_facts_volume_uom_name;
        // convertedAmount = conversions.volume(baseAmount, baseAmountUoM, ing_product.serving_amount_custom_uom);
        // old logic
        baseAmount = ing_product.custom_uom_base_values.unit_amount * baseAmountScale;
        baseAmountUoM = ing_product.custom_uom_base_values.unit_type;
        convertedAmount = conversions.volume(baseAmount, baseAmountUoM, ing_product.serving_amount_custom_uom);

        // // console.log("convertedAmount volume final ", convertedAmount, baseAmountScale, baseAmount);
      }
      // // console.log("convertedAmount unit ", this.uomType(ing_product.serving_amount_custom_uom));
      if (this.uomType(ing_product.serving_amount_custom_uom) === 'Unit' && ing_product.custom_uom_base_values) {

        let baseAmount = ing_product.nutrition_facts_weight;
        let baseAmountUoM = ing_product.nutrition_facts_weight_uom_name;
        convertedAmount = conversions.weight(baseAmount, baseAmountUoM, ing_product.custom_uom_base_values.weight_units);

        let baseAmountScale = convertedAmount / ing_product.custom_uom_base_values.weight;
        baseAmount = ing_product.custom_uom_base_values.unit_amount * baseAmountScale;

        // baseAmount = ing_product.custom_uom_base_values.unit_amount / ing_product.custom_uom_base_values.weight;
        convertedAmount = baseAmount;

        // console.log("convertedAmount unit ", convertedAmount, baseAmount);

        // // console.log("convertedAmount volume final unit ", convertedAmount, baseAmountScale, baseAmount);
      }
    }

    // if(ing_uom_type === 'Custom'){
    //     if(this.uomType(ing_product.serving_amount_custom_uom) === 'Weight' &&  )
    // }

    // // console.log('convertedAmount  ', ing_amount, convertedAmount);

    let scale_factor = ing_amount / convertedAmount;

    // // console.log('convertedAmount getMenuClycleNutritionScaleFactor ', ing_amount, convertedAmount);

    if (isFinite(scale_factor) && !isNaN(scale_factor) && scale_factor !== null) {
      return scale_factor;
    } else {
      return 0;
    }

  }
  ,

  checkIsNull(cVal, ucVal) {
    if (ucVal != null) {
      if (cVal != null) {
        return this.ConvertToDecimal(parseFloat(cVal) + parseFloat(ucVal));
      } else {
        return ucVal;
      }
    } else {
      return cVal;
    }
  },

  checkIsNullOriginal(cVal, ucVal) {
    if (ucVal != null) {
      if (cVal != null) {
        return parseFloat(cVal) + parseFloat(ucVal);
      } else {
        return ucVal;
      }
    } else {
      return cVal;
    }
  },

  ConvertToDecimal(num) {
    if (this.isFloat(num)) {
      return this.nearestValue(num);
      // num = Math.round(num * 100) / 100;

      // num = parseFloat(num);

      // // return num;
      // num = num.toString(); //If it's not already a String
      // num = num.slice(0, (num.indexOf(".")) + 3); //With 3 exposing the hundredths place

      // return Number(num);
    } else {
      return Number(num);
    }
  },
  isFloat(value) {
    if (
      typeof value === 'number' &&
      !Number.isNaN(value) &&
      !Number.isInteger(value)
    ) {
      return true;
    }

    return false;
  },

  checkIfNull(cVal, ucVal) {
    if (cVal != null && parseFloat(cVal) >= 0) {
      return cVal;
    } else {
      return ucVal
    }
  },

  getRecipeTotal(recipes, serve_logic, ignoreBplOverride = false) {
    // serve_logic
    console.log('recipes getRecipeTotal asdf', recipes);
    let $this = this;
    let total = this.getBlankObject();
    let nutraions = this.getBlankNutration();
    if (recipes.length > 0) {

      const keys = Object.keys(total);
      if (serve_logic) {
        let RecipeCount = 0;
        let RecipeTotal = this.getBlankObject();
        recipes.forEach((value) => {

          let recipe_milk = null;
          if (value.category == 'Milk') {
            if (value.is_override) {
              recipe_milk = $this.checkIsNull(recipe_milk, $this.checkIfNull(value.total_val_override['MLK'], value.total_val['MLK']));
            } else {
              recipe_milk = $this.checkIsNull(recipe_milk, value.total_val?.MLK ?? null);
            }
          }

          if (recipe_milk > 0) {
            RecipeCount++;
            keys.forEach((key, index) => {
              if (key == 'MLK') {
                if (value.is_override && !nutraions.includes(key)) {
                  console.log('navin milk in if');
                  if ($this.checkIsNull(0, $this.checkIfNull(value.total_val_override[key], value.total_val[key])) > 1) {
                    RecipeTotal[key] += 1;
                  } else {
                    RecipeTotal[key] += $this.checkIsNull(0, $this.checkIfNull(value.total_val_override[key], value.total_val[key]));
                  }
                } else {
                  if ($this.checkIsNull(0, value.total_val[key]) > 1) {
                    RecipeTotal[key] += 1;
                  } else {
                    RecipeTotal[key] += $this.checkIsNullOriginal(0, value.total_val[key]);
                  }
                }
              } else if (value.is_override && !nutraions.includes(key) && !(ignoreBplOverride && key === 'BPL')) {
                RecipeTotal[key] += $this.checkIsNull(0, $this.checkIfNull(value.total_val_override[key], value.total_val[key]));
              } else {
                RecipeTotal[key] += $this.checkIsNullOriginal(0, value.total_val[key]);
              }
            });
          }
        });

        // console.log("RecipeTotals start", RecipeTotal);
        keys.forEach((key, index) => {
          if (RecipeTotal[key] > 0 && key != 'MLK') {
            RecipeTotal[key] = RecipeTotal[key] / RecipeCount;
          }
        });
        // console.log("RecipeTotals total final", RecipeTotal);
        total = RecipeTotal;
      }

      recipes.forEach((value) => {
        let recipe_milk = null;
        if (value.category == 'Milk') {
          if (value.is_override) {
            recipe_milk = $this.checkIsNull(recipe_milk, $this.checkIfNull(value.total_val_override['MLK'], value.total_val['MLK']));
          } else {
            recipe_milk = $this.checkIsNull(recipe_milk, value.total_val['MLK']);
          }
        } else {
          value.total_val['MLK'] = null;
        }
        // console.log("recipes getRecipeTotal asdf recipe_milk", recipe_milk, serve_logic);
        // if(!(recipe_milk > 0)){
        keys.forEach((key, index) => {
          if (!(serve_logic && recipe_milk > 0)) {

            if (value.is_override && !nutraions.includes(key) && !(ignoreBplOverride && key === 'BPL')) {
              total[key] = $this.checkIsNull(total[key], $this.checkIfNull(value.total_val_override[key], value.total_val[key]));
            } else {
              total[key] = $this.checkIsNullOriginal(total[key], value.total_val[key]);
            }

            // if(key == 'MLK'){
            //     // console.log("recipes getRecipeTotal asdf total['MLK'] if ", value.total_val_override['MLK'], value.total_val['MLK'],  $this.checkIfNull(value.total_val_override[key], value.total_val[key]), 'total[key]', total[key]);
            // }
          } else {
            // if(key == 'MLK'){
            //     total[key] = null;
            // }
          }
        });
        // console.log("recipes getRecipeTotal asdf total['MLK']", total['MLK']);
        // }
      });

      // #990 START
      // total['DG'] = 0;
      // total['RO'] = 0;  
      // total['BPL'] = 0;
      // total['STAR'] = 0;
      // total['OTH'] = 0;
      // // total['VEG'] = 0;

      // recipes.forEach((value) => {
      //   // 'VEG',
      //   let vegKeys = [ 'DG', 'RO', 'BPL', 'STAR', 'OTH'];
      //   vegKeys.forEach((key, index) => {           
      //     if(value.total_val[key] > total[key]){             
      //       total[key] = value.total_val[key];
      //     }
      //   });

      //   // if(value.total_val['VEG'] > 0 && (value.total_val['VEG'] < total['VEG'] || total['VEG'] == 0)){
      //   //   total['VEG'] = value.total_val['VEG'];
      //   // } 

      // });
      // #990 END



      return total;
    } else {
      return total;
    }
  },

  getDayMinimumeValue(days) {
    // //// console.log("days", days);
    let $this = this;
    let total = this.getBlankObject();
    // //// console.log("blank total", total);
    const keys = Object.keys(total);
    const nutration = this.getBlankNutration();
    if (days.length > 0) {
      days.forEach((value) => {
        if (!value.a_la_carte) {
          keys.forEach((key, index) => {
            if (nutration.includes(key)) {
              // //// console.log("nutraion ", key);
              if (value?.total_val?.hasOwnProperty(key)) {
                total[key] = $this.checkIsNullOriginal(total[key], value.total_val[key]);
              }
            } else {
              if (value?.total_val?.hasOwnProperty(key)) {
                if (key == 'MLK' && $this.getMinValue(total[key], value.total_val[key]) > 0) {
                  total[key] = 1;
                } else {
                  // VEG KEYS
                  let vegKeys = ['DG', 'RO', 'BPL', 'STAR', 'OTH'];
                  if (vegKeys.includes(key)) {
                    total[key] = $this.getMaxValue(total[key], value.total_val[key]);
                  } else {
                    // if (value.total_val[key] > 0) {
                    //     if(key == 'VEG'){
                    //     total[key]  = total[key] + value.total_val[key];
                    //   } 
                    // }
                    // if(key != 'VEG')
                    // {
                    total[key] = $this.getMinValue(total[key], value.total_val[key]);
                    // }

                  }

                }
              }
            }
          });
        }

      });

      // // //// console.log("days total", total);
      // nutration.forEach((key, index) => {
      //   // //// console.log("nutration.forEach", key, total[key] , days.length, total[key] / days.length);
      //   // if(total[key]){
      //   // total[key] = total[key] / days.length;
      //   total[key] = total[key];
      //   // }
      // });

      // //// console.log("days total 1 ", total);
      return total;
    } else {
      return total;
    }
  },

  getMaxValue(cVal, ucVal) {
    if (ucVal != null) {
      if (cVal != null) {
        if (parseFloat(cVal) < parseFloat(ucVal)) {
          return parseFloat(ucVal);
        } else {
          return cVal;
        }
      } else {
        return ucVal;
      }
    } else {
      return cVal;
    }
  },
  getMinValue(cVal, ucVal) {
    if (ucVal != null) {
      if (cVal != null) {
        if (parseFloat(cVal) > parseFloat(ucVal)) {
          return parseFloat(ucVal);
        } else {
          return cVal;
        }
      } else {
        return ucVal;
      }
    } else {
      return cVal;
    }
  },

  getWeeklyAvg(days, total_days) {
    let $this = this;
    // console.error("getWeeklyAvg new", days);
    let total = {};

    if (days.length > 0) {
      total = this.getBlankObject();
      const nutration = this.getBlankNutration();
      const keys = Object.keys(total);
      days.forEach((value) => {
        if (value != null && Object.keys(value).length > 0) {
          // //// console.log("getWeeklyAvg value", total);
          keys.forEach((key, index) => {
            total[key] = $this.checkIsNull(total[key], value[key]);
            // //// console.log("getWeeklyAvg value total", total);
          });
        }
      });

      // total['SATFAT (%)'] = (total['satfat'] / total['FAT']) * 100;
      // total['CALS (%)'] = (total['added_sugars'] / total['CALS']) * 100;


      //// console.log("getWeeklyAvg total ", total);
      nutration.forEach((key, index) => {
        // //// console.log("nutration.forEach", key, total[key] , days.length, total[key] / days.length);
        // if(total[key]){
        total[key] = (total[key] / total_days).toFixed(3);
        // }
      });
      total['CALS (%)'] = this.getCalPercentage(total['added_sugars'], total['CALS']);
      total['SATFAT (%)'] = this.getSatFatPercentage(total['satfat'], total['CALS']);

      // console.error("getWeeklyAvg total ", total, total['added_sugars'], total['CALS (%)']);
      // //// console.log("getWeeklyAvg total 1", total);
      return total;
    } else {
      // //// console.log("getWeeklyAvg total else", total);
      return total;
    }


  },

  getWeeklyAvgWithBplBase(days, allDaysOptions, total_days, serve_logic) {
    let $this = this;
    let clonedDays = days.map((daySum, index) => {
      if (daySum == null) {
        return daySum;
      }
      let isArray = Array.isArray(daySum);
      let daySumObj = isArray ? daySum[0] : daySum;
      if (daySumObj == null || Object.keys(daySumObj).length === 0) {
        return daySum;
      }
      let clonedObj = { ...daySumObj };
      let dayOptions = allDaysOptions[index];
      if (dayOptions && dayOptions.length > 0) {
        let dayBplValues = [];
        dayOptions.forEach((option) => {
          if (!option.a_la_carte && option.recipes && option.recipes.length > 0) {
            let optionTotalsWithoutBplOverride = $this.getRecipeTotal(option.recipes, serve_logic, true);
            dayBplValues.push(parseFloat(optionTotalsWithoutBplOverride['BPL']) || 0);
          }
        });
        if (dayBplValues.length > 0) {
          clonedObj['BPL'] = Math.max(...dayBplValues);
        } else {
          clonedObj['BPL'] = 0;
        }
      } else {
        clonedObj['BPL'] = 0;
      }
      return isArray ? [clonedObj] : clonedObj;
    });
    return this.getWeeklyAvg(clonedDays, total_days);
  },

  getByName(recipe) {
    if (!recipe) {
      return '';
    }
    // console.log('recipe-recipe', recipe);
    let $this = this;
    const keys = Object.keys(this.getBlankObject());
    const nutration = this.getBlankNutration();
    let name = [];
    // // console.log("getByName recipe", recipe);
    keys.forEach((key, index) => {
      if (recipe[key] != null && recipe[key] > 0) {
        if (nutration.includes(key)) {
          if (key === 'sugar') {
            name.push($this.roundToThousandths(recipe[key]) + 'Total Sugar');
          } else if (key === 'added_sugars') {
            name.push($this.roundToThousandths(recipe[key]) + 'Added sugars');
          }

          else {
            name.push($this.roundToThousandths(recipe[key]) + key);
          }
        } else {
          // console.log('component key', key, nutration);
          if (key === 'WGR') {
            name.push($this.ConvertToDecimal(recipe[key]) + 'GRA');
          } else {
            name.push($this.ConvertToDecimal(recipe[key]) + key);
          }

        }

      }
    });
    // //// console.log("getByName recipe return ", name.join(', '));
    return name.join(', ');
  },

  getByFirstName(recipe) {
    const keys = Object.keys(this.getBlankObject());
    let name = "";
    keys.forEach((key, index) => {
      if (recipe[key] != null && recipe[key] > 0) {
        if (name != '') {
          return false;
        }
        if (key === 'WGR') {
          name = recipe[key] + 'GRA';
        } else {
          name = recipe[key] + key;
        }

      }
    });
    return name;
  },

  getBlankNutration() {
    return [
      'CALS', 'SOD',
      'added_sugars', 'FAT', 'CARB', 'PROT',
      'calfat',
      'satfat',
      'transfat',
      'polysatfat',
      'monosatfat',
      'cholesterol',
      'potassium',
      'fiber',
      'sugar',
      'vitamina',
      'vitaminb6',
      'vitaminb12',
      'vitaminc',
      'vitamind',
      'vitamine',
      'calcium',
      'iron',
      'magnesium',
      'coblamin',
      'thiamin',
      'riboflavin',
      'niacin',
      'zinc',
      'water',
      'ash'
    ]
  },

  getBlankObject() {
    return {
      'MMA': null,
      'WGR': null,
      'FRU': null,
      'MLK': null,
      'VEG': null,
      'DG': null,
      'RO': null,
      'BPL': null,
      'STAR': null,
      'OTH': null,
      'CALS': null,
      'SOD': null,
      'added_sugars': null,
      'satfat': null,
      'CARB': null,
      'PROT': null,
      'FAT': null,
      'calfat': null,

      'transfat': null,
      'polysatfat': null,
      'monosatfat': null,
      'cholesterol': null,
      'potassium': null,
      'fiber': null,
      'sugar': null,
      'vitamina': null,
      'vitaminb6': null,
      'vitaminb12': null,
      'vitaminc': null,
      'vitamind': null,
      'vitamine': null,
      'calcium': null,
      'iron': null,
      'magnesium': null,
      'coblamin': null,
      'thiamin': null,
      'riboflavin': null,
      'niacin': null,
      'zinc': null,
      'water': null,
      'ash': null,

    };
  },


  /**
   * ************************************************************************************
   * Conver MenuCycle to showing array
   * ************************************************************************************
   */
  getNutritionKeys() {

    return ['CALS', 'SOD', 'added_sugars', 'satfat', 'CARB', 'calfat', 'transfat', 'polysatfat', 'monosatfat', 'cholesterol', 'potassium', 'fiber', 'sugar', 'PROT', 'vitamina', 'vitaminb6', 'vitaminb12', 'vitaminc', 'vitamind', 'vitamine', 'calcium', 'iron', 'magnesium', 'coblamin', 'thiamin', 'riboflavin', 'niacin', 'zinc', 'water', 'ash', 'FAT'];
  },

  convertMenuCycleToShowingData(menuCycle, week, serve_logic) {
    let $this = this;
    const nutirtionsValues = $this.getNutritionKeys();

    let total_val = [];
    // // console.log('recipes menuCycle', menuCycle);
    menuCycle.all_prefer_products = [];
    menuCycle.all_options = [];
    menuCycle.menu_cycle_days = menuCycle.menu_cycle_days.map((menu_cycle_day, index) => {
      menu_cycle_day.all_prefer_products = [];

      if (menu_cycle_day.options.length) {
        let totalLength = 1;
        totalLength = menu_cycle_day.options.reduce((total, option) => total + option.planned_number, 0);
        // // console.log('totalLength of options menucycle', totalLength);

        menu_cycle_day.options.map((options, option_index) => {
          let optionPlannedNumber = options.planned_number;
          let optionPercentage = (optionPlannedNumber / totalLength) * 100;

          if (options.recipes && options.recipes.length > 0) {
            options.recipes.map((value, index) => {
              menu_cycle_day.all_prefer_products.push(value['prefer_products']);
              menuCycle.all_prefer_products.push(value['prefer_products']);
              // // console.log("value.total_val", value.total_val);
              value.total_val = $this.sum_products_week_popup_totals_new_override(value['prefer_products'], value);
              console.log('convertMenuCycleToShowingData value.total_val', value.total_val, value.name);
            });
            options.new_total_val = $this.getRecipeTotal(options.recipes, serve_logic);
            options.total_val = $this.getRecipeTotal(options.recipes, serve_logic);



            for (const key in options.total_val) {
              if (nutirtionsValues.includes(key)) {
                options.total_val[key] = (options.total_val[key] * optionPercentage) / 100;
              }
            }
          }

          console.log('convertMenuCycleToShowingData options.total_val', options.total_val, options);

          // options.total_val = $this.getRecipeTotal(options.recipes);
          // //// console.log("options", options);
          return options;
          // options.option_min_total_val = $this.getRecipeTotal(options.recipes);
        });
        menuCycle.all_options = menuCycle.all_options.concat(menu_cycle_day.options);
      }

      // menu_cycle_day.is_additional = $this.getAdditionalProductsMenuPlanner(menuCycle.guideline, menu_cycle_day.all_prefer_products, 'daily');

      menu_cycle_day.is_additional = $this.getAdditionalProductsMenuPlanner1(menuCycle.guideline, menu_cycle_day.options, 'daily');

      // // console.log("convertMenuCycleToShowingData 1 ", menu_cycle_day);


      menu_cycle_day.date = week.days[menu_cycle_day.day_of_week_number - 1];
      menu_cycle_day.total_val = $this.getDayMinimumeValue(menu_cycle_day.options);
      menu_cycle_day.is_guidline = $this.checkGuidlineValue(menuCycle.guideline, menu_cycle_day.total_val, 'daily');
      total_val.push(menu_cycle_day.total_val);

      console.log('convertMenuCycleToShowingData menu_cycle_day.total_val', menu_cycle_day.total_val, menu_cycle_day);

      return menu_cycle_day;
    });

    menuCycle.total_val = this.getWeeklyAvgWithBplBase(total_val, menuCycle.menu_cycle_days.map(d => d.options), menuCycle.day.total_days, serve_logic);
    menuCycle.is_guidline = $this.checkGuidlineValue(menuCycle.guideline, menuCycle.total_val, 'weekly');

    // menuCycle.is_additional = $this.getAdditionalProductsMenuPlanner(menuCycle.guideline, menuCycle.all_prefer_products, 'weekly');

    // menuCycle.is_additional = false;
    menuCycle.is_additional = $this.getAdditionalProductsMenuPlanner1(menuCycle.guideline, menuCycle.all_options, 'weekly');

    // // console.log("convertMenuCycleToShowingData 1", menuCycle);

    return menuCycle;
  },

  // daily weekly
  checkGuidlineValue(guideline, total_val, checkType) {
    let $this = this;
    let guidline_vals = this.getAllGuidLineParam(checkType);
    const nutration = this.getBlankNutration();
    //this.getBlankObject();
    let returnVal = true;

    const keys = Object.keys(guidline_vals);
    keys.forEach((key, index) => {
      let rt;
      if (nutration.includes(key)) {
        rt = $this.checkGuidLineValidOrNot(guideline, guidline_vals, key, total_val, 'nutrtion');
      } else {
        rt = $this.checkGuidLineValidOrNot(guideline, guidline_vals, key, total_val, 'component');
      }
      if (!rt) {
        // // console.log("greenreddot checkGuidlineValue false ", key, total_val, guidline_vals, checkType);
        returnVal = false;
      }
    });
    return returnVal;
  },

  checkGuidLineValidOrNot(guideline, guidline_vals, keys, total_val, is_nutrtion) {
    let min = guideline[guidline_vals[keys][0]];
    let max = guideline[guidline_vals[keys][1]];
    let validReturn = true;
    //// console.log("checkGuidLineValidOrNot start", keys  ,total_val, total_val[keys]);
    let gValid = this.checkGuildLineVals(min, max, total_val[keys], is_nutrtion);

    if (gValid == 'red') {
      // // console.log("greenreddot checkGuidLineValidOrNot red ", gValid, keys, min, max, total_val, total_val[keys], is_nutrtion);
      return false;
    } else {
      //// console.log("checkGuidLineValidOrNot end");
      return validReturn;
    }
    // if(this.checkIfNull(min, null)){
    //   if(this.checkIfNull(total_val[keys], null)){
    //     if(this.checkIfNull(min, null) > this.checkIfNull(total_val[keys], null)){
    //       return false;
    //     }
    //   } else {
    //     return false;
    //   }
    // }


    // if(this.checkIfNull(max, null)){
    //   if(this.checkIfNull(total_val[keys], null)){
    //     if(this.checkIfNull(max, null) < this.checkIfNull(total_val[keys], null)){
    //       return false;
    //     }
    //   } else {
    //     return false;
    //   }
    // }

  },

  checkGuildLineVals(gMin, gMax, cVal, cType) {

    //// console.log("checkGuildLineVals gMin, gMax, cVal helper ",gMin, gMax, cVal, cType);
    // check guildline min or max value for is not null or 0
    if (this.checkIntOrNotNull(gMin) || this.checkIntOrNotNull(gMax)) {
      let returnVal = 'green';
      // check guidline min value is not null or 0
      if (this.checkIntOrNotNull(gMin)) {

        // check guidline min value <= cVal
        if (this.checkIntOrNotNull(cVal) && gMin <= parseFloat(cVal)) {
          // return 'green';
        } else {
          //// console.log("this.checkIntOrNotNull(cVal) min red ", this.checkIntOrNotNull(cVal));
          return 'red';
        }
      }

      // check guidline max value is not null or 0
      if (this.checkIntOrNotNull(gMax)) {
        // check guidline max value <= cVal
        if (this.checkIntOrNotNull(cVal) && gMax >= parseFloat(cVal)) {
          // returnVal = 'green';
        } else {
          if (cType == 'component') {
            //// console.log('gray max component', gMax, cVal, cType);
            returnVal = 'gray';

          } else {
            if (!this.checkIntOrNotNull(gMin) && cVal <= gMax) {
              returnVal = 'green';
            } else {
              returnVal = 'red';
            }
          }
        }
      }
      return returnVal;
    } else {
      if (cType == 'component') {
        return 'gray';

      } else {
        return 'green';
      }
    }
  },

  checkGuildLineVals1(gMin, gMax, cVal, cType) {

    // console.log("checkGuildLineVals1 gMin, gMax, cVal helper ",gMin, gMax, cVal, cType);
    // check guildline min or max value for is not null or 0
    if (this.checkIntOrNotNull(gMin) || this.checkIntOrNotNull(gMax)) {
      let returnVal = 'green';
      // check guidline min value is not null or 0
      if (this.checkIntOrNotNull(gMin)) {

        // check guidline min value <= cVal
        if (this.checkIntOrNotNull(cVal) && gMin <= parseFloat(cVal)) {
          // return 'green';
        } else {
          //// console.log("this.checkIntOrNotNull(cVal) min red ", this.checkIntOrNotNull(cVal));
          return 'red';
        }
      }
      console.log("checkGuildLineVals1 min ", returnVal);

      // check guidline max value is not null or 0
      if (this.checkIntOrNotNull(gMax)) {
        // check guidline max value <= cVal
        if (this.checkIntOrNotNull(cVal) && gMax >= parseFloat(cVal)) {
          // returnVal = 'green';
        } else {
          if (cType == 'component') {
            returnVal = 'gray';

          } else {
            if (!this.checkIntOrNotNull(gMin)) {
              returnVal = 'green';
            } else {
              returnVal = 'red';
            }
          }
        }
      }
      console.log("checkGuildLineVals1 max ", returnVal);
      return returnVal;
    } else {
      if (cType == 'component') {
        return 'gray';

      } else {
        return 'green';
      }
    }
  },


  getAllGuidLineParam(types) {
    return {
      'MMA': [types + '_min_usda_componenent_serving_meat', types + '_max_usda_componenent_serving_meat'],
      'WGR': [types + '_min_usda_componenent_serving_grain', types + '_max_usda_componenent_serving_grain'],
      'FRU': [types + '_min_usda_componenent_serving_fruit', types + '_max_usda_componenent_serving_fruit'],
      'MLK': [types + '_min_usda_componenent_serving_milk', types + '_max_usda_componenent_serving_milk'],
      'VEG': [types + '_min_usda_componenent_serving_veg', types + '_max_usda_componenent_serving_veg'],
      'BPL': [types + '_min_usda_componenent_serving_vegleg', types + '_max_usda_componenent_serving_vegleg'],
      'RO': [types + '_min_usda_componenent_serving_vegred', types + '_max_usda_componenent_serving_vegred'],
      'DG': [types + '_min_usda_componenent_serving_veggrn', types + '_max_usda_componenent_serving_veggrn'],
      'STAR': [types + '_min_usda_componenent_serving_vegstar', types + '_max_usda_componenent_serving_vegstar'],
      'OTH': [types + '_min_usda_componenent_serving_vegothr', types + '_max_usda_componenent_serving_vegothr'],

      'CALS': [types + '_min_nutrition_facts_calories', types + '_max_nutrition_facts_calories'],
      'SOD': [types + '_min_nutrition_facts_sodium', types + '_max_nutrition_facts_sodium'],
      'FAT': [types + '_min_nutrition_facts_totalfat', types + '_max_nutrition_facts_totalfat'],
      'PROT': [types + '_min_nutrition_facts_protein', types + '_max_nutrition_facts_protein'],
      'CARB': [types + '_min_nutrition_facts_carbs', types + '_max_nutrition_facts_carbs'],

      'calfat': [types + '_min_nutrition_facts_calfat', types + '_max_nutrition_facts_calfat'],
      'satfat': [types + '_min_nutrition_facts_satfat', types + '_max_nutrition_facts_satfat'],
      'transfat': [types + '_min_nutrition_facts_transfat', types + '_max_nutrition_facts_transfat'],
      'polysatfat': [types + '_min_nutrition_facts_polysatfat', types + '_max_nutrition_facts_polysatfat'],
      'monosatfat': [types + '_min_nutrition_facts_monosatfat', types + '_max_nutrition_facts_monosatfat'],
      'cholesterol': [types + '_min_nutrition_facts_cholesterol', types + '_max_nutrition_facts_cholesterol'],
      'potassium': [types + '_min_nutrition_facts_potassium', types + '_max_nutrition_facts_potassium'],
      'fiber': [types + '_min_nutrition_facts_fiber', types + '_max_nutrition_facts_fiber'],
      'sugar': [types + '_min_nutrition_facts_sugar', types + '_max_nutrition_facts_sugar'],
      'vitamina': [types + '_min_nutrition_facts_vitamina', types + '_max_nutrition_facts_vitamina'],
      'vitaminb6': [types + '_min_nutrition_facts_vitaminb6', types + '_max_nutrition_facts_vitaminb6'],
      'vitaminb12': [types + '_min_nutrition_facts_vitaminb12', types + '_max_nutrition_facts_vitaminb12'],
      'vitaminc': [types + '_min_nutrition_facts_vitaminc', types + '_max_nutrition_facts_vitaminc'],
      'vitamind': [types + '_min_nutrition_facts_vitamind', types + '_max_nutrition_facts_vitamind'],
      'vitamine': [types + '_min_nutrition_facts_vitamine', types + '_max_nutrition_facts_vitamine'],
      'calcium': [types + '_min_nutrition_facts_calcium', types + '_max_nutrition_facts_calcium'],
      'iron': [types + '_min_nutrition_facts_iron', types + '_max_nutrition_facts_iron'],
      'magnesium': [types + '_min_nutrition_facts_magnesium', types + '_max_nutrition_facts_magnesium'],
      'coblamin': [types + '_min_nutrition_facts_coblamin', types + '_max_nutrition_facts_coblamin'],
      'thiamin': [types + '_min_nutrition_facts_thiamin', types + '_max_nutrition_facts_thiamin'],
      'riboflavin': [types + '_min_nutrition_facts_riboflavin', types + '_max_nutrition_facts_riboflavin'],
      'niacin': [types + '_min_nutrition_facts_niacin', types + '_max_nutrition_facts_niacin'],
      'zinc': [types + '_min_nutrition_facts_zinc', types + '_max_nutrition_facts_zinc'],
      'water': [types + '_min_nutrition_facts_water', types + '_max_nutrition_facts_water'],
      'ash': [types + '_min_nutrition_facts_ash', types + '_max_nutrition_facts_ash'],
      'added_sugars': [types + '_min_nutrition_facts_added_sugars', types + '_max_nutrition_facts_added_sugars']
    }
  },

  checkIntOrNotNull(cVal) {
    if (!isNaN(cVal)) {
      if (cVal > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },

  getAdditionalProducts(gline, prod, returnText, type) {

    // console.log('getAdditionalProducts123 hello', prod);
    // if(prod?.length == 0 && type == 'daily'){
    //   return returnText;
    // }
    let isWholeGrains = false;
    let TotalGrain = [];
    let TotalWholeGrain = [];
    let TotalWholeGrainDessert = 0;

    let isJuice = false;
    let JuiceCondition = '';
    let JuiceCount = 0;
    let JuiceWeeklyCount = [];
    let FruitWeeklyCount = [];
    let FruitCount = 0;

    let isVegJuice = false;
    let JuiceVegCondition = '';
    let JuiceVegCount = 0;
    let JuiceVegWeeklyCount = [];
    let VegWeeklyCount = [];
    let VegCount = 0;

    let isMilk = false;
    let MilkCondition = '';
    let MilkConditionArray = [];
    let MilkUseKeys = [];
    let MilkKeys = this.getAllMilkKey();

    // milk_variety
    let isMilkVariety = false;
    let TargetMilkVariety = 0;
    let MilkVarietyCondition = '';
    let MilkVarietyArray = [];

    let after_school_cond_1 = false;
    let after_school_cond_2 = false;
    let after_school_cond_3 = false;
    let after_school_cond_4 = false;

    let daily_afterschool_snack = false;

    if (type == 'daily' && gline.daily_afterschool_snack && gline.daily_afterschool_snack.description) {
      daily_afterschool_snack = true;
    }

    if (gline[type + '_milk_variety']) {
      isMilkVariety = true;
      MilkVarietyCondition = gline[type + '_milk_variety'].conditions;
      TargetMilkVariety = gline[type + '_milk_variety'].target;
    }


    if (type == 'weekly' && gline[type + '_juices']) {
      isJuice = true;
      JuiceCondition = gline[type + '_juices'].max_unit_served;
    }


    if (type == 'weekly' && gline[type + '_veg_juices']) {
      isVegJuice = true;
      JuiceVegCondition = gline[type + '_veg_juices'].max_unit_served;
    }

    if (gline[type + '_milks']?.length > 0) {
      isMilk = true;
      gline[type + '_milks'].forEach((milk, index) => {
        let mk = this.ConvertGuidlineToMilkKey(milk.flavored, milk.milk_fat);
        MilkUseKeys.push(mk);

        if (index !== 0) {
          MilkCondition += milk.and_or === 'or' ? ' || ' : ' && ';
        }
        let mca = '';
        mca += milk.operator === 'is not' ? ' ! ( ' : '';
        mca += `[${mk}] ${milk.symbol} ${milk.units}`;
        mca += milk.operator === 'is not' ? ' )' : '';
        MilkCondition += mca;
        MilkConditionArray.push({ 'condition': mca, 'description': milk.description });
      });
    }

    if (gline[type + '_whole_grains']?.is_whole_grains_dessert >= 0 || gline[type + '_whole_grains']?.percent_of_total_grains_served >= 0) {
      isWholeGrains = true;
    }

    // console.log('getAdditionalProducts123 recipe', prod );

    if (prod?.length > 0 && (isJuice || isMilk || isWholeGrains || daily_afterschool_snack || isMilkVariety || isVegJuice)) {

      prod.forEach(option => {

        let OptionJuice = 0;
        let OptionFruit = 0;

        let OptionJuiceVeg = 0;
        let OptionVeg = 0;



        if (option?.recipes.length > 0) {
          let RecipeJuice = 0;
          let RecipeFruit = 0;
          let RecipeVegJuice = 0;
          let RecipeVeg = 0;



          option.recipes.forEach(recipe => {
            // console.log('getAdditionalProducts123 recipe', recipe );
            let RecipeMilkVariety = { 'is_the_milk_flavored': 0, 'milk_fat_content': '' };

            // console.log('getAdditionalProducts123 recipe', recipe.name,  recipe.total_val );
            if (recipe.total_val['MMA'] >= 1) {
              after_school_cond_2 = true;
            }

            if (recipe.total_val['FRU'] > 0 || recipe.total_val['VEG'] > 0) {
              after_school_cond_3 = true;
            }

            if (recipe.total_val['FRU'] > 0) {
              RecipeFruit += recipe.total_val['FRU'];
              if (recipe.total_val['override_is_fruit_juice'] > 0) {
                RecipeJuice += recipe.total_val['FRU'];
              }
            }

            if (recipe.total_val['VEG'] > 0) {
              RecipeVeg += recipe.total_val['VEG'];
              if (recipe.total_val['override_is_veg_juice'] > 0) {
                RecipeVegJuice += recipe.total_val['VEG'];
              }
            }

            if (recipe.total_val['WGR'] > 0) {
              TotalGrain.push(recipe.total_val['WGR']);
              if (recipe.total_val['override_is_whole_grains_info'] > 0) {
                TotalWholeGrain.push(recipe.total_val['WGR']);
              }
              if (recipe.total_val['override_is_whole_grains_dessert'] > 0) {
                // TotalWholeGrainDessert.push(recipe.total_val['WGR']);
                TotalWholeGrainDessert += recipe.total_val['WGR'];
              }
            }

            if (recipe.total_val['MLK'] > 0) {
              after_school_cond_4 = true;
              MilkKeys = this.ConvertRecipeToMilkKey(MilkKeys, recipe.total_val);

              if (recipe.total_val['override_is_the_milk_flavored'] > 0) {
                RecipeMilkVariety.is_the_milk_flavored = 1;
              }

              //
              if (['Whole Milk', 'Reduced Fat 2%', 'Low Fat 1%', 'Fat-Free / Skim'].includes(recipe.total_val['override_milk_fat_content'])) {
                RecipeMilkVariety.milk_fat_content = recipe.total_val['override_milk_fat_content'];
              }
            }

            if (RecipeMilkVariety.milk_fat_content != '') {
              MilkVarietyArray.push(RecipeMilkVariety);
            }
          });
          OptionJuice = Math.max(RecipeJuice, OptionJuice);
          OptionFruit = Math.max(RecipeFruit, OptionFruit);

          OptionJuiceVeg = Math.max(RecipeVegJuice, OptionJuiceVeg);
          OptionVeg = Math.max(RecipeVeg, OptionVeg);
        }


        // Fruit Juice
        if (JuiceWeeklyCount.hasOwnProperty(option.day_of_week)) {
          JuiceWeeklyCount[option.day_of_week] = Math.max(JuiceWeeklyCount[option.day_of_week], OptionJuice);
        } else {
          JuiceWeeklyCount[option.day_of_week] = OptionJuice;
        }

        // Fruit
        if (FruitWeeklyCount.hasOwnProperty(option.day_of_week)) {
          FruitWeeklyCount[option.day_of_week] = Math.max(FruitWeeklyCount[option.day_of_week], OptionFruit);
        } else {
          FruitWeeklyCount[option.day_of_week] = OptionFruit;
        }


        // Veg Juice
        if (JuiceVegWeeklyCount.hasOwnProperty(option.day_of_week)) {
          JuiceVegWeeklyCount[option.day_of_week] = Math.max(JuiceVegWeeklyCount[option.day_of_week], OptionJuiceVeg);
        } else {
          JuiceVegWeeklyCount[option.day_of_week] = OptionJuiceVeg;
        }

        // Veg
        if (VegWeeklyCount.hasOwnProperty(option.day_of_week)) {
          VegWeeklyCount[option.day_of_week] = Math.max(VegWeeklyCount[option.day_of_week], OptionVeg);
        } else {
          VegWeeklyCount[option.day_of_week] = OptionVeg;
        }

      });
    }


    if (isJuice) {
      JuiceCount = Object.values(JuiceWeeklyCount).reduce((a, b) => a + b, 0);
      FruitCount = Object.values(FruitWeeklyCount).reduce((a, b) => a + b, 0);
      // console.log("juice123 JuiceCount", JuiceCount, FruitCount, JuiceCondition);

      if (JuiceCount <= 0 && FruitCount <= 0) {
        isJuice = false;
      } else {
        let jc = JuiceCount / FruitCount * 100;
        if (JuiceCondition >= jc) {
          isJuice = false;
        }
      }
    }

    if (isVegJuice) {
      JuiceVegCount = Object.values(JuiceVegWeeklyCount).reduce((a, b) => a + b, 0);
      VegCount = Object.values(VegWeeklyCount).reduce((a, b) => a + b, 0);
      // console.log("juice123 JuiceVegCount", JuiceVegCount, VegCount, JuiceVegCondition);

      if (JuiceVegCount <= 0 && VegCount <= 0) {
        isVegJuice = false;
      } else {
        let jc = JuiceVegCount / VegCount * 100;
        if (JuiceVegCondition >= jc) {
          isVegJuice = false;
        }
      }
    }

    if (isMilk) {
      if (this.CheckMilkCondition(MilkCondition, MilkKeys)) {
        isMilk = false;
      }
    }

    if (isMilkVariety && TargetMilkVariety > 0) {
      // console.log('checkMilkGuideline', this.checkMilkGuideline(gline, MilkVarietyArray, type));
      if (!this.checkMilkGuideline(gline, MilkVarietyArray, type)) {
        returnText.push('Milk Variety : ' + gline[type + '_milk_variety'].description);
      }

    }

    // console.log('isMilkVariety', MilkVarietyArray, gline, MilkVarietyCondition, 'returnText', returnText);


    // console.log('isMilkVariety', MilkVarietyArray, MilkVarietyCondition, 'returnText', returnText);

    // console.log('grain total', 'TotalGrain', TotalGrain, 'TotalWholeGrain', TotalWholeGrain);

    let sumTotalGrain = TotalGrain.reduce(function (a, b) {
      return parseInt(a) + parseInt(b);
    }, 0);
    let sumTotalWholeGrain = TotalWholeGrain.reduce(function (a, b) {
      return parseInt(a) + parseInt(b);
    }, 0);
    const pGrain = (sumTotalWholeGrain / sumTotalGrain) * 100;

    if (isWholeGrains) {

      if (sumTotalGrain > 0) {
        const percentGrainsServed = gline[type + '_whole_grains'].percent_of_total_grains_served;

        const maxDessertWholeGrain = gline[type + '_whole_grains'].maximum_dessert_whole_grain;

        if (percentGrainsServed && percentGrainsServed >= 0 && maxDessertWholeGrain && maxDessertWholeGrain > 0) {
          if (percentGrainsServed <= pGrain && maxDessertWholeGrain >= TotalWholeGrainDessert) {
            console.log("isWholeGrains 1");
            isWholeGrains = false;
          }
        } else if (percentGrainsServed && percentGrainsServed <= pGrain) {
          console.log("isWholeGrains 2");
          isWholeGrains = false;
        } else if (maxDessertWholeGrain && maxDessertWholeGrain >= TotalWholeGrainDessert) {
          console.log("isWholeGrains 3");
          isWholeGrains = false;
        }
        console.log("isWholeGrains ", percentGrainsServed, maxDessertWholeGrain, sumTotalGrain, sumTotalWholeGrain, TotalWholeGrainDessert, pGrain, isWholeGrains);
      }
    }


    if (isJuice) {
      returnText.push(gline[type + '_juices'].description);
    }

    if (isVegJuice) {
      returnText.push(gline[type + '_veg_juices'].description);
    }


    if (isMilk) {
      let $this = this;
      MilkConditionArray.forEach(option => {
        // // console.log("MilkCondition ", option);
        if (!$this.CheckMilkCondition(option.condition, MilkKeys)) {
          returnText.push(option.description);
        }
      });
      // returnText.push(gline[type+'_milks_description']);
    }

    // console.log("isWholeGrains last", isWholeGrains);

    if (isWholeGrains) {
      // // console.log("isWholeGrains final", isWholeGrains, gline[type + '_whole_grains'].description);
      returnText.push(gline[type + '_whole_grains'].description);
    }


    if (type == 'daily' && gline.daily_afterschool_snack && gline.daily_afterschool_snack.description) {
      after_school_cond_1 = pGrain >= 50;
      // console.log("after_school_cond", after_school_cond_1, after_school_cond_2, after_school_cond_3, after_school_cond_4, pGrain, sumTotalWholeGrain, sumTotalGrain);
      if (!((after_school_cond_1 && after_school_cond_2) || ((after_school_cond_1 || after_school_cond_2) && (after_school_cond_3 || after_school_cond_4)))) {
        returnText.push(gline.daily_afterschool_snack.description);
      }
    }

    return returnText;
  },

  getAdditionalProducts1(gline, prod, returnText, type) {

    console.log('getAdditionalProducts', gline, prod, returnText, type);
    // if(prod?.length == 0 && type == 'daily'){
    //   return returnText;
    // }
    let isWholeGrains = false;
    let TotalGrain = [];
    let TotalWholeGrain = [];
    let TotalWholeGrainDessert = 0;

    let isJuice = false;
    let JuiceCondition = '';
    let JuiceCount = 0;
    let JuiceWeeklyCount = [];
    let FruitWeeklyCount = [];
    let FruitCount = 0;

    let isVegJuice = false;
    let JuiceVegCondition = '';
    let JuiceVegCount = 0;
    let JuiceVegWeeklyCount = [];
    let VegWeeklyCount = [];
    let VegCount = 0;

    let isMilk = false;
    let MilkCondition = '';
    let MilkConditionArray = [];
    let MilkUseKeys = [];
    let MilkKeys = this.getAllMilkKey();

    // milk_variety
    let isMilkVariety = false;
    let TargetMilkVariety = 0;
    let MilkVarietyCondition = '';
    let MilkVarietyArray = [];

    let after_school_cond_1 = false;
    let after_school_cond_2 = false;
    let after_school_cond_3 = false;
    let after_school_cond_4 = false;

    let daily_afterschool_snack = false;

    if (type == 'daily' && gline.daily_afterschool_snack && gline.daily_afterschool_snack.description) {
      daily_afterschool_snack = true;
    }

    if (gline[type + '_milk_variety']) {
      isMilkVariety = true;
      MilkVarietyCondition = gline[type + '_milk_variety'].conditions;
      TargetMilkVariety = gline[type + '_milk_variety'].target;
    }


    if (type == 'weekly' && gline[type + '_juices']) {
      isJuice = true;
      JuiceCondition = gline[type + '_juices'].max_unit_served;
    }


    if (type == 'weekly' && gline[type + '_veg_juices']) {
      isVegJuice = true;
      JuiceVegCondition = gline[type + '_veg_juices'].max_unit_served;
    }

    if (gline[type + '_milks']?.length > 0) {
      isMilk = true;
      gline[type + '_milks'].forEach((milk, index) => {
        let mk = this.ConvertGuidlineToMilkKey(milk.flavored, milk.milk_fat);
        MilkUseKeys.push(mk);

        if (index !== 0) {
          MilkCondition += milk.and_or === 'or' ? ' || ' : ' && ';
        }
        let mca = '';
        mca += milk.operator === 'is not' ? ' ! ( ' : '';
        mca += `[${mk}] ${milk.symbol} ${milk.units}`;
        mca += milk.operator === 'is not' ? ' )' : '';
        MilkCondition += mca;
        MilkConditionArray.push({ 'condition': mca, 'description': milk.description });
      });
    }

    if (gline[type + '_whole_grains']?.is_whole_grains_dessert >= 0 || gline[type + '_whole_grains']?.percent_of_total_grains_served >= 0) {
      isWholeGrains = true;
    }


    // // console.log('getAdditionalProducts', prod);
    // let pIndex = 0;
    if (prod?.length > 0 && (isJuice || isMilk || isWholeGrains || daily_afterschool_snack || isMilkVariety || isVegJuice)) {

      prod.forEach(option => {

        let OptionJuice = 0;
        let OptionFruit = 0;

        let OptionJuiceVeg = 0;
        let OptionVeg = 0;

        if (option?.recipes.length > 0) {
          let RecipeJuice = 0;
          let RecipeFruit = 0;
          let RecipeVegJuice = 0;
          let RecipeVeg = 0;

          option.recipes.forEach(recipe => {
            let RecipeMilkVariety = { 'is_the_milk_flavored': 0, 'milk_fat_content': '' };

            let isOverride = false;
            let checkMilk = true;
            let checkGrain = true;
            let checkGrainW = true;
            let checkGrainWD = true;
            let checkFruit = true;
            let rFruit = 0;
            let checkVeg = true;
            let rVeg = 0;

            console.log('grain store start', recipe.name);


            if (recipe.is_calculation_total_override) {
              isOverride = true;

              // Milk is override in recipe
              if (recipe.is_the_milk_flavored == 'Yes') {
                RecipeMilkVariety.is_the_milk_flavored = 1;
                checkMilk = false;
              }

              if (['Whole Milk', 'Reduced Fat 2%', 'Low Fat 1%', 'Fat-Free / Skim'].includes(recipe.milk_fat_content)) {
                RecipeMilkVariety.milk_fat_content = recipe.milk_fat_content;
                checkMilk = false;
              }

              if (!checkMilk) {
                MilkKeys = this.ConvertProductToMilkKey(MilkKeys, recipe);
                after_school_cond_4 = true;
              }

              const vjuice = recipe.calculation_total_override?.WGR;
              if (vjuice !== undefined) {

              }

              // Grain is override in recipe
              let wgr = recipe.calculation_total_override?.WGR;

              if (wgr !== undefined) {
                wgr = parseInt(wgr);
                checkGrain = false;
                TotalGrain.push(wgr);
                console.log('grain store override', wgr);
              }


              console.log('grain store recipe is_whole_grains_info in', recipe.is_whole_grains_info);

              if (['Yes', 'No'].includes(recipe.is_whole_grains_info)) {

                checkGrainW = false;

                if (recipe.is_whole_grains_info === 'Yes') {
                  TotalWholeGrain.push(wgr);
                }

                console.log('grain store recipe is_whole_grains_dessert in', recipe.is_whole_grains_dessert);

                if (['Yes', 'No'].includes(recipe.is_whole_grains_dessert)) {
                  checkGrainWD = false;

                  if (recipe.is_whole_grains_dessert === 'Yes') {
                    TotalWholeGrainDessert += wgr;
                  }
                }
              }

              // Fruit Juice is override in recipe
              let fru = recipe.calculation_total_override?.FRU;

              if (fru !== undefined) {
                rFruit = parseInt(fru);
                checkFruit = false;
                if (fru > 0) {
                  after_school_cond_3 = true;
                  // RecipeFruit += fru;
                }
              }

              let veg = recipe.calculation_total_override?.VEG;

              if (veg !== undefined) {
                rFruit = parseInt(veg);
                checkVeg = false;
                if (veg > 0) {
                  after_school_cond_3 = true;

                }
              }

              // if (['Yes', 'No'].includes(recipe.is_the_product_juice)) {
              //     checkFruitJuice = false;
              //     if (recipe.is_the_product_juice == 'Yes') {
              //         RecipeJuice += product.usda_componenent_serving_fruit1;
              //     }
              // }
            }

            if (recipe?.all_prefer_products) {
              recipe.all_prefer_products.forEach(product => {

                if (product.usda_componenent_serving_meat1 >= 1) {
                  after_school_cond_2 = true;
                }

                // Check Juice Condition
                if ((checkFruit && product.usda_componenent_serving_fruit1 > 0) || (checkVeg && product.usda_componenent_serving_veg1 > 0)) {
                  after_school_cond_3 = true;
                }

                let fruitValue = 0;
                if (rFruit > 0) {
                  fruitValue = rFruit;
                } else if (product.usda_componenent_serving_fruit1 > 0) {
                  fruitValue = product.usda_componenent_serving_fruit1;
                }

                if (fruitValue > 0) {
                  RecipeFruit += fruitValue;

                  let juiceFlag = recipe.is_the_product_juice;
                  if (!['Yes', 'No'].includes(juiceFlag)) {
                    juiceFlag = product.is_the_product_juice;
                  }

                  if (juiceFlag === 'Yes') {
                    RecipeJuice += fruitValue;
                  }
                }

                // Veg
                let vegValue = 0;
                if (rVeg > 0) {
                  vegValue = rVeg;
                } else if (product.usda_componenent_serving_veg1 > 0) {
                  vegValue = product.usda_componenent_serving_veg1;
                }

                if (vegValue > 0) {
                  RecipeVeg += vegValue;

                  let juiceVegFlag = recipe.is_the_product_juice;
                  if (!['Yes', 'No'].includes(juiceVegFlag)) {
                    juiceVegFlag = product.is_the_product_juice;
                  }

                  if (juiceVegFlag === 'Yes') {
                    RecipeVegJuice += vegValue;
                  }
                }

                // if(product.usda_componenent_serving_veg1 > 0){
                //     RecipeVeg += product.usda_componenent_serving_veg1;
                //     if (product.is_the_product_juice == 'Yes') {
                //         RecipeVegJuice += product.usda_componenent_serving_veg1;
                //     }
                // }

                // if(rFruit > 0){
                //     RecipeFruit += rFruit;
                //     if (['Yes', 'No'].includes(recipe.is_the_product_juice)) {                                    
                //         if (recipe.is_the_product_juice == 'Yes') {
                //             RecipeJuice += rFruit;
                //         }
                //     } else {
                //         if (['Yes', 'No'].includes(product.is_the_product_juice)) {                                    
                //             if (product.is_the_product_juice == 'Yes') {
                //                 RecipeJuice += rFruit;
                //             }
                //         }
                //     }
                // }
                // else if(product.usda_componenent_serving_fruit1 > 0){
                //     RecipeFruit += product.usda_componenent_serving_fruit1;
                //     if (['Yes', 'No'].includes(recipe.is_the_product_juice)) {                                    
                //         if (recipe.is_the_product_juice == 'Yes') {
                //             RecipeJuice += rFruit;
                //         }
                //     } else {
                //         if (['Yes', 'No'].includes(product.is_the_product_juice)) {                                    
                //             if (product.is_the_product_juice == 'Yes') {
                //                 RecipeJuice += rFruit;
                //             }
                //         }
                //     }
                // } 
                // else if(product.usda_componenent_serving_fruit1 > 0){
                //     RecipeFruit += product.usda_componenent_serving_fruit1;
                //     if (product.is_the_product_juice == 'Yes') {
                //         RecipeJuice += product.usda_componenent_serving_fruit1;
                //     }
                // } 

                // if(product.usda_componenent_serving_veg1 > 0){
                //     RecipeVeg += product.usda_componenent_serving_veg1;
                //     if (product.is_the_product_juice == 'Yes') {
                //         RecipeVegJuice += product.usda_componenent_serving_veg1;
                //     }
                // }

                if (checkMilk && product.usda_componenent_serving_milk1 > 0) {
                  MilkKeys = this.ConvertProductToMilkKey(MilkKeys, product);
                  after_school_cond_4 = true;



                  if (product.is_the_milk_flavored == 'Yes') {
                    RecipeMilkVariety.is_the_milk_flavored = 1;
                  }

                  //
                  if (['Whole Milk', 'Reduced Fat 2%', 'Low Fat 1%', 'Fat-Free / Skim'].includes(product.milk_fat_content)) {
                    RecipeMilkVariety.milk_fat_content = product.milk_fat_content;
                  }
                }




                // Check Grain
                let usda_componenent_serving_grain1 = parseInt(product.usda_componenent_serving_grain1);
                console.log('grain store recipe product usda_componenent_serving_grain1', usda_componenent_serving_grain1);
                // if (usda_componenent_serving_grain1 > 0) {
                // Sum of total grain
                if (checkGrain && usda_componenent_serving_grain1 > 0) {
                  TotalGrain.push(usda_componenent_serving_grain1);
                }


                if (product.is_whole_grains_info == 'Yes' && checkGrainW) {
                  TotalWholeGrain.push(usda_componenent_serving_grain1);
                  if (product.is_whole_grains_dessert == 'Yes' && checkGrainWD) {
                    TotalWholeGrainDessert += usda_componenent_serving_grain1;
                  }
                }

                // }

              });
            }

            if (RecipeMilkVariety.milk_fat_content != '') {
              MilkVarietyArray.push(RecipeMilkVariety);
            }
          });
          OptionJuice = Math.max(RecipeJuice, OptionJuice);
          OptionFruit = Math.max(RecipeFruit, OptionFruit);

          OptionJuiceVeg = Math.max(RecipeVegJuice, OptionJuiceVeg);
          OptionVeg = Math.max(RecipeVeg, OptionVeg);
        }


        // Fruit Juice
        if (JuiceWeeklyCount.hasOwnProperty(option.day_of_week)) {
          JuiceWeeklyCount[option.day_of_week] = Math.max(JuiceWeeklyCount[option.day_of_week], OptionJuice);
        } else {
          JuiceWeeklyCount[option.day_of_week] = OptionJuice;
        }

        // Fruit
        if (FruitWeeklyCount.hasOwnProperty(option.day_of_week)) {
          FruitWeeklyCount[option.day_of_week] = Math.max(FruitWeeklyCount[option.day_of_week], OptionFruit);
        } else {
          FruitWeeklyCount[option.day_of_week] = OptionFruit;
        }


        // Veg Juice
        if (JuiceVegWeeklyCount.hasOwnProperty(option.day_of_week)) {
          JuiceVegWeeklyCount[option.day_of_week] = Math.max(JuiceVegWeeklyCount[option.day_of_week], OptionJuiceVeg);
        } else {
          JuiceVegWeeklyCount[option.day_of_week] = OptionJuiceVeg;
        }

        // Veg
        if (VegWeeklyCount.hasOwnProperty(option.day_of_week)) {
          VegWeeklyCount[option.day_of_week] = Math.max(VegWeeklyCount[option.day_of_week], OptionVeg);
        } else {
          VegWeeklyCount[option.day_of_week] = OptionVeg;
        }

      });
    }


    if (isJuice) {
      JuiceCount = Object.values(JuiceWeeklyCount).reduce((a, b) => a + b, 0);
      FruitCount = Object.values(FruitWeeklyCount).reduce((a, b) => a + b, 0);

      if (JuiceCount < 0 && FruitCount < 0) {
        isJuice = false;
      } else {
        let jc = JuiceCount / FruitCount * 100;
        if (JuiceCondition >= jc) {
          isJuice = false;
        }
      }
    }

    if (isVegJuice) {
      JuiceVegCount = Object.values(JuiceVegWeeklyCount).reduce((a, b) => a + b, 0);
      VegCount = Object.values(VegWeeklyCount).reduce((a, b) => a + b, 0);

      if (JuiceVegCount < 0 && VegCount < 0) {
        isVegJuice = false;
      } else {
        let jc = JuiceVegCount / VegCount * 100;
        if (JuiceVegCondition >= jc) {
          isVegJuice = false;
        }
      }
    }

    if (isMilk) {
      if (this.CheckMilkCondition(MilkCondition, MilkKeys)) {
        isMilk = false;
      }
    }

    if (isMilkVariety && TargetMilkVariety > 0) {
      // console.log('checkMilkGuideline', this.checkMilkGuideline(gline, MilkVarietyArray, type));
      if (!this.checkMilkGuideline(gline, MilkVarietyArray, type)) {
        returnText.push('Milk Variety : ' + gline[type + '_milk_variety'].description);
      }

    }


    // console.log('isMilkVariety', MilkVarietyArray, MilkVarietyCondition, 'returnText', returnText);

    console.log("grain calculation start");
    console.log("grain calculation ", 'TotalGrain', TotalGrain);
    console.log("grain calculation ", 'TotalWholeGrain', TotalWholeGrain);

    let sumTotalGrain = TotalGrain.reduce(function (a, b) {
      return parseInt(a) + parseInt(b);
    }, 0);
    let sumTotalWholeGrain = TotalWholeGrain.reduce(function (a, b) {
      return parseInt(a) + parseInt(b);
    }, 0);

    console.log("grain calculation ", 'sumTotalGrain', sumTotalGrain);
    console.log("grain calculation ", 'sumTotalWholeGrain', sumTotalWholeGrain);


    const pGrain = (sumTotalWholeGrain / sumTotalGrain) * 100;
    console.log("grain calculation ", 'pGrain', pGrain);

    if (isWholeGrains) {

      if (sumTotalGrain > 0) {

        const percentGrainsServed = gline[type + '_whole_grains'].percent_of_total_grains_served;

        const maxDessertWholeGrain = gline[type + '_whole_grains'].maximum_dessert_whole_grain;

        console.log("grain calculation ", 'percentGrainsServed', percentGrainsServed);
        console.log("grain calculation ", 'maxDessertWholeGrain', maxDessertWholeGrain);

        if (percentGrainsServed && percentGrainsServed >= 0 && maxDessertWholeGrain && maxDessertWholeGrain > 0) {


          console.log("grain calculation if", percentGrainsServed && percentGrainsServed >= 0, maxDessertWholeGrain && maxDessertWholeGrain > 0);

          console.log("grain calculation if if ", percentGrainsServed <= maxDessertWholeGrain >= TotalWholeGrainDessert);

          if (percentGrainsServed <= pGrain && maxDessertWholeGrain >= TotalWholeGrainDessert) {
            console.log("isWholeGrains 1",);
            isWholeGrains = false;
          }
        } else if (percentGrainsServed && percentGrainsServed <= pGrain) {
          console.log("isWholeGrains 2");
          isWholeGrains = false;
        } else if (maxDessertWholeGrain && maxDessertWholeGrain >= TotalWholeGrainDessert) {
          console.log("isWholeGrains 3");
          isWholeGrains = false;
        }

        // console.log("grain calculation end ", 'isWholeGrains', isWholeGrains);

      }
    }


    if (isJuice) {
      returnText.push(gline[type + '_juices'].description);
    }

    if (isVegJuice) {
      returnText.push(gline[type + '_veg_juices'].description);
    }


    if (isMilk) {
      let $this = this;
      MilkConditionArray.forEach(option => {
        // // console.log("MilkCondition ", option);
        if (!$this.CheckMilkCondition(option.condition, MilkKeys)) {
          returnText.push(option.description);
        }
      });
      // returnText.push(gline[type+'_milks_description']);
    }

    // console.log("isWholeGrains last", isWholeGrains);

    if (isWholeGrains) {
      // // console.log("isWholeGrains final", isWholeGrains, gline[type + '_whole_grains'].description);
      returnText.push(gline[type + '_whole_grains'].description);
    }


    if (type == 'daily' && gline.daily_afterschool_snack && gline.daily_afterschool_snack.description) {
      after_school_cond_1 = pGrain >= 50;
      // console.log("after_school_cond", after_school_cond_1, after_school_cond_2, after_school_cond_3, after_school_cond_4, pGrain, sumTotalWholeGrain, sumTotalGrain);
      if (!((after_school_cond_1 && after_school_cond_2) || ((after_school_cond_1 || after_school_cond_2) && (after_school_cond_3 || after_school_cond_4)))) {
        returnText.push(gline.daily_afterschool_snack.description);
      }
    }

    return returnText;
  },

  checkMilkGuideline(guideline, conditions = [], type = '') {
    let matchCount = null;
    const name = `${type}_milk_variety`;
    const milkVariety = guideline[name];

    if (milkVariety && milkVariety.target && milkVariety.target > 0) {
      const target = milkVariety.target;
      const gConditions = milkVariety.conditions;

      if (gConditions.length > 0) {
        matchCount = gConditions.filter(item => {
          const isTheMilkFlavored = item.flavored === 'Flavored' ? 1 : 0;
          const milkFat = item.milk_fat;

          return conditions.some(condition => {
            return (
              isTheMilkFlavored === condition.is_the_milk_flavored &&
              milkFat === condition.milk_fat_content
            );
          });
        }).length;

        let isUnflavored = conditions.some(condition => condition.is_the_milk_flavored == 0);

        return (target <= matchCount && isUnflavored);
      }
    }

    return '';
  },

  // ADDITIONAL REQUIREMENT for milk
  getAllMilkKey() {
    return {
      "Total": 0,
      "Flavored": 0,
      "Unflavored": 0,
      "WholeMilk": 0,
      "ReducedFat": 0,
      "LowFat": 0,
      "FatFree": 0,
      "FlavoredWholeMilk": 0,
      "FlavoredReducedFat": 0,
      "FlavoredLowFat": 0,
      "FlavoredFatFree": 0,
      "UnflavoredWholeMilk": 0,
      "UnflavoredReducedFat": 0,
      "UnflavoredLowFat": 0,
      "UnflavoredFatFree": 0
    };
  },

  ConvertProductToMilkKey(milkKey, product) {
    milkKey['Total'] += 1;

    const milk_fat_content = product.milk_fat_content;
    const is_the_milk_flavored = product.is_the_milk_flavored === 'Yes' ? 'Flavored' : 'Unflavored';

    const guidelineKey1 = this.ConvertGuidlineToMilkKey(is_the_milk_flavored, milk_fat_content);
    const guidelineKey2 = this.ConvertGuidlineToMilkKey('null', milk_fat_content);
    const guidelineKey3 = this.ConvertGuidlineToMilkKey(is_the_milk_flavored, 'null');

    milkKey[guidelineKey1] += 1;
    milkKey[guidelineKey2] += 1;
    milkKey[guidelineKey3] += 1;

    return milkKey;
  },
  ConvertRecipeToMilkKey(milkKey, product) {
    milkKey['Total'] += 1;

    const milk_fat_content = product.override_milk_fat_content;
    const is_the_milk_flavored = product.override_is_the_milk_flavored === 'Yes' ? 'Flavored' : 'Unflavored';

    const guidelineKey1 = this.ConvertGuidlineToMilkKey(is_the_milk_flavored, milk_fat_content);
    const guidelineKey2 = this.ConvertGuidlineToMilkKey('null', milk_fat_content);
    const guidelineKey3 = this.ConvertGuidlineToMilkKey(is_the_milk_flavored, 'null');

    milkKey[guidelineKey1] += 1;
    milkKey[guidelineKey2] += 1;
    milkKey[guidelineKey3] += 1;

    return milkKey;
  },

  ConvertGuidlineToMilkKey(flavored, milk_fat) {
    // console.log('flavored, milk_fat', flavored, milk_fat);

    let name = '';

    if (flavored === 'null' && milk_fat === 'null') {
      return 'Total';
    }

    if (flavored === 'Flavored') {
      name = 'Flavored';
    } else if (flavored === 'Unflavored') {
      name = 'Unflavored';
    }

    if (milk_fat === 'Whole Milk') {
      name += 'WholeMilk';
    } else if (milk_fat === 'Reduced Fat 2%') {
      name += 'ReducedFat';
    } else if (milk_fat === 'Low Fat 1%') {
      name += 'LowFat';
    } else if (milk_fat === 'Fat-Free / Skim') {
      name += 'FatFree';
    }

    return name;
  },


  // check milk conditions
  CheckMilkCondition(condition, milkKeys) {
    // console.log("CheckMilkCondition", milkKeys, condition);
    let isCond = false;
    if (condition != null) {
      for (const [key, value] of Object.entries(milkKeys)) {
        // console.log(`${key}: ${value}`);
        condition = condition.replaceAll('[' + key + ']', value);
      }
      isCond = eval(condition);
    }
    // // console.log("CheckMilkCondition 1", condition);
    return isCond;
  },

  // Check ADDITIONAL REQUIREMENT for juice

  CheckJuiceCondition(condition, VegJuiceArray, FruitJuiceArray) {
    // console.log('CheckJuiceCondition', condition, 'VegJuiceArray', VegJuiceArray, 'FruitJuiceArray', FruitJuiceArray);

    for (let Veg of VegJuiceArray) {
      let jCondition = condition.replaceAll("[Veg]", Veg);

      if (FruitJuiceArray.length > 0) {
        for (let Fruit of FruitJuiceArray) {
          let jCondition1 = jCondition.replaceAll("[Fruit]", Fruit);

          if (eval(jCondition1)) {
            // console.log("CheckJuiceCondition true Fruit Veg =", jCondition1);
            return true;
          }
        }
      } else {
        jCondition = jCondition.replaceAll("[Fruit]", 0);
        // console.log("CheckJuiceCondition true Veg=", jCondition);
        if (eval(jCondition)) {
          return true;
        }
      }
    }

    for (let Fruit of FruitJuiceArray) {
      let jCondition = condition.replaceAll("[Fruit]", Fruit);
      jCondition = jCondition.replaceAll("[Veg]", 0);

      if (eval(jCondition)) {
        // console.log("CheckJuiceCondition true Fruit = ", jCondition);
        return true;
      }
    }
    // console.log("CheckJuiceCondition true end = ", false);
    return false;
  },



  getAdditionalProductsMenuPlanner(gline, prod, type) {

    let isWholeGrains = false;
    let TotalGrain = [];
    let TotalWholeGrain = [];
    let TotalWholeGrainDessert = 0;


    let isJuice = false;
    let JuiceCondition = '';
    let JuiceCount = 0;
    let JuiceWeeklyCount = [];

    let isMilk = false;
    let MilkCondition = '';
    let MilkConditionArray = [];
    let MilkUseKeys = [];
    let MilkKeys = this.getAllMilkKey();
    let returnText = [];

    let after_school_cond_1 = false;
    let after_school_cond_2 = false;
    let after_school_cond_3 = false;
    let after_school_cond_4 = false;


    let daily_afterschool_snack = false;

    if (type == 'daily' && gline.daily_afterschool_snack && gline.daily_afterschool_snack.description) {
      daily_afterschool_snack = true;
    }

    if (gline[type + '_juices']) {
      isJuice = true;
      JuiceCondition = gline[type + '_juices'].max_unit_served;
    }

    if (gline[type + '_milks']?.length > 0) {

      isMilk = true;
      gline[type + '_milks'].forEach((milk, index) => {
        let mk = this.ConvertGuidlineToMilkKey(milk.flavored, milk.milk_fat);
        MilkUseKeys.push(mk);

        if (index !== 0) {
          MilkCondition += milk.and_or === 'or' ? ' || ' : ' && ';
        }
        let mca = '';
        mca += milk.operator === 'is not' ? ' ! ( ' : '';
        mca += `[${mk}] ${milk.symbol} ${milk.units}`;
        mca += milk.operator === 'is not' ? ' )' : '';
        MilkCondition += mca;
        MilkConditionArray.push({ 'condition': mca, 'description': milk.description });
      });
    }

    if (gline[type + '_whole_grains']?.is_whole_grains_dessert >= 0 || gline[type + '_whole_grains']?.percent_of_total_grains_served >= 0) {
      isWholeGrains = true;
    }


    // console.log('getAdditionalProducts prods', prod);
    if (prod?.length > 0 && (isJuice || isMilk || isWholeGrains || daily_afterschool_snack)) {
      prod.forEach(prod1 => {
        // console.log("getAdditionalProducts prod1", prod1);
        prod1.forEach(product => {
          // console.log("getAdditionalProducts product", product);
          // console.log("juice", isJuice, product.usda_componenent_serving_fruit1, product.usda_componenent_serving_veg1, product);

          if (product.usda_componenent_serving_meat1 >= 1) {
            after_school_cond_2 = true;
          }

          // Check Juice Condition
          // if(isJuice && product.is_the_product_juice == 'Yes'){
          if (product.usda_componenent_serving_fruit1 > 0 || product.usda_componenent_serving_veg1 > 0) {
            after_school_cond_3 = true;
          }
          if ((product.usda_componenent_serving_fruit1 > 0 || product.usda_componenent_serving_veg1 > 0) && product.is_the_product_juice == 'Yes') {

            // JuiceCount++;
            if (JuiceWeeklyCount.hasOwnProperty(product.day_id)) {
              if (JuiceWeeklyCount[product.day_id].hasOwnProperty(product.option_id)) {
                JuiceWeeklyCount[product.day_id][product.option_id]++;
                // console.log("JuiceWeeklyCount JuiceOptions ++ ", JuiceWeeklyCount);
              } else {
                JuiceWeeklyCount[product.day_id][product.option_id] = 1;
              }
            } else {
              JuiceWeeklyCount[product.day_id] = {
                [product.option_id]: 1
              };
            }
          }

          // Check Milk Condition
          //// console.log("MilkCondition", MilkCondition, MilkUseKeys);
          if (product.usda_componenent_serving_milk1 > 0) {
            MilkKeys = this.ConvertProductToMilkKey(MilkKeys, product);
            after_school_cond_4 = true;
          }

          let usda_componenent_serving_grain1 = parseInt(product.usda_componenent_serving_grain1);
          if (isWholeGrains && usda_componenent_serving_grain1 > 0) {
            // Sum of total grain
            TotalGrain.push(usda_componenent_serving_grain1);

            if (product.is_whole_grains_info == 'Yes') {
              TotalWholeGrain.push(usda_componenent_serving_grain1);
              if (product.is_whole_grains_dessert == 'Yes') {
                TotalWholeGrainDessert += usda_componenent_serving_grain1;
              }
            }
          }

        });
      });
    }

    // console.log("JuiceWeeklyCount", JuiceWeeklyCount);

    if (isJuice) {
      let JuiceTotal = [];
      let JuiceDay = Object.keys(JuiceWeeklyCount);

      if (JuiceDay.length > 0) {
        for (let day_id of JuiceDay) {
          let JuiceOptions = Object.values(JuiceWeeklyCount[day_id]);
          // console.log("JuiceWeeklyCount JuiceOptions", JuiceOptions);
          // console.log("JuiceWeeklyCount JuiceOptions max", Math.max(...JuiceOptions));
          let TotalJuiceOption = Math.max(...JuiceOptions);
          if (JuiceTotal.hasOwnProperty(day_id)) {
            JuiceTotal[day_id] = Math.max(JuiceTotal[day_id], TotalJuiceOption);
          } else {
            JuiceTotal[day_id] = TotalJuiceOption;
          }

          // JuiceWeeklyCount[day_id].
        }
        JuiceCount = Object.values(JuiceTotal).reduce((a, b) => a + b, 0);
        // console.log("JuiceWeeklyCount JuiceTotal", type, JuiceTotal, JuiceCount);
      }

      // console.log("JuiceCondition JuiceCount", JuiceCondition, JuiceCount);

      if (JuiceCondition >= JuiceCount) {
        isJuice = false;
      }
    }

    if (isMilk) {
      if (this.CheckMilkCondition(MilkCondition, MilkKeys)) {
        isMilk = false;
      }
    }

    let sumTotalGrain = TotalGrain.reduce(function (a, b) {
      return parseInt(a) + parseInt(b);
    }, 0);
    let sumTotalWholeGrain = TotalWholeGrain.reduce(function (a, b) {
      return parseInt(a) + parseInt(b);
    }, 0);
    const pGrain = (sumTotalWholeGrain / sumTotalGrain) * 100;

    if (isWholeGrains) {


      if (sumTotalGrain > 0) {
        const percentGrainsServed = gline[type + '_whole_grains'].percent_of_total_grains_served;

        const maxDessertWholeGrain = gline[type + '_whole_grains'].maximum_dessert_whole_grain;


        if (percentGrainsServed && percentGrainsServed >= 0 && maxDessertWholeGrain && maxDessertWholeGrain > 0) {
          if (percentGrainsServed <= pGrain && maxDessertWholeGrain >= TotalWholeGrainDessert) {
            // // console.log("isWholeGrains 1");
            isWholeGrains = false;
          }
        } else if (percentGrainsServed && percentGrainsServed <= pGrain) {
          // // console.log("isWholeGrains 2");
          isWholeGrains = false;
        } else if (maxDessertWholeGrain && maxDessertWholeGrain >= TotalWholeGrainDessert) {
          // // console.log("isWholeGrains 3");
          isWholeGrains = false;
        }
        // // console.log("isWholeGrains ", percentGrainsServed, maxDessertWholeGrain, sumTotalGrain, sumTotalWholeGrain, TotalWholeGrainDessert, pGrain, isWholeGrains);
      }
    }


    if (isJuice) {
      returnText.push(gline[type + '_juices'].description);
    }

    if (isMilk) {
      let $this = this;
      MilkConditionArray.forEach(option => {
        // // console.log("MilkCondition ", option);
        if (!$this.CheckMilkCondition(option.condition, MilkKeys)) {
          returnText.push(option.description);
        }
      });
      // returnText.push(gline[type+'_milks_description']);
    }


    if (isWholeGrains) {
      // // console.log("isWholeGrains final", isWholeGrains, gline[type + '_whole_grains'].description);
      returnText.push(gline[type + '_whole_grains'].description);
    }

    if (type == 'daily' && gline.daily_afterschool_snack && gline.daily_afterschool_snack.description) {
      after_school_cond_1 = pGrain >= 50;
      if (!((after_school_cond_1 && after_school_cond_2) || ((after_school_cond_1 || after_school_cond_2) && (after_school_cond_3 || after_school_cond_4)))) {
        returnText.push(gline.daily_afterschool_snack.description);
      }
    }


    return (returnText.length > 0) ? false : true;
  },

  getAdditionalProductsMenuPlanner1(gline, prod, type) {

    // console.log('getAdditionalProducts', gline, prod, returnText, type);
    let returnText = [];
    // if(prod?.length == 0 && type == 'daily'){
    //   return returnText;
    // }
    let isWholeGrains = false;
    let TotalGrain = [];
    let TotalWholeGrain = [];
    let TotalWholeGrainDessert = 0;

    let isJuice = false;
    let JuiceCondition = '';
    let JuiceCount = 0;
    let JuiceWeeklyCount = [];
    let FruitWeeklyCount = [];
    let FruitCount = 0;

    let isVegJuice = false;
    let JuiceVegCondition = '';
    let JuiceVegCount = 0;
    let JuiceVegWeeklyCount = [];
    let VegWeeklyCount = [];
    let VegCount = 0;

    let isMilk = false;
    let MilkCondition = '';
    let MilkConditionArray = [];
    let MilkUseKeys = [];
    let MilkKeys = this.getAllMilkKey();

    // milk_variety
    let isMilkVariety = false;
    let TargetMilkVariety = 0;
    let MilkVarietyCondition = '';
    let MilkVarietyArray = [];

    let after_school_cond_1 = false;
    let after_school_cond_2 = false;
    let after_school_cond_3 = false;
    let after_school_cond_4 = false;

    let daily_afterschool_snack = false;

    if (type == 'daily' && gline.daily_afterschool_snack && gline.daily_afterschool_snack.description) {
      daily_afterschool_snack = true;
    }

    if (gline[type + '_milk_variety']) {
      isMilkVariety = true;
      MilkVarietyCondition = gline[type + '_milk_variety'].conditions;
      TargetMilkVariety = gline[type + '_milk_variety'].target;
    }


    if (type == 'weekly' && gline[type + '_juices']) {
      isJuice = true;
      JuiceCondition = gline[type + '_juices'].max_unit_served;
    }


    if (type == 'weekly' && gline[type + '_veg_juices']) {
      isVegJuice = true;
      JuiceVegCondition = gline[type + '_veg_juices'].max_unit_served;
    }

    if (gline[type + '_milks']?.length > 0) {
      isMilk = true;
      gline[type + '_milks'].forEach((milk, index) => {
        let mk = this.ConvertGuidlineToMilkKey(milk.flavored, milk.milk_fat);
        MilkUseKeys.push(mk);

        if (index !== 0) {
          MilkCondition += milk.and_or === 'or' ? ' || ' : ' && ';
        }
        let mca = '';
        mca += milk.operator === 'is not' ? ' ! ( ' : '';
        mca += `[${mk}] ${milk.symbol} ${milk.units}`;
        mca += milk.operator === 'is not' ? ' )' : '';
        MilkCondition += mca;
        MilkConditionArray.push({ 'condition': mca, 'description': milk.description });
      });
    }

    if (gline[type + '_whole_grains']?.is_whole_grains_dessert >= 0 || gline[type + '_whole_grains']?.percent_of_total_grains_served >= 0) {
      isWholeGrains = true;
    }


    // // console.log('getAdditionalProducts', prod);
    // let pIndex = 0;
    if (prod?.length > 0 && (isJuice || isMilk || isWholeGrains || daily_afterschool_snack || isMilkVariety || isVegJuice)) {

      prod.forEach(option => {

        let OptionJuice = 0;
        let OptionFruit = 0;

        let OptionJuiceVeg = 0;
        let OptionVeg = 0;
        console.log('option', option);
        if (option?.recipes.length > 0) {
          let RecipeJuice = 0;
          let RecipeFruit = 0;
          let RecipeVegJuice = 0;
          let RecipeVeg = 0;

          option.recipes.forEach(recipe => {
            // console.log('getAdditionalProducts123 recipe', recipe );
            let RecipeMilkVariety = { 'is_the_milk_flavored': 0, 'milk_fat_content': '' };

            // console.log('getAdditionalProducts123 recipe', recipe.name,  recipe.total_val );
            if (recipe.total_val['MMA'] >= 1) {
              after_school_cond_2 = true;
            }

            if (recipe.total_val['FRU'] > 0 || recipe.total_val['VEG'] > 0) {
              after_school_cond_3 = true;
            }

            if (recipe.total_val['FRU'] > 0) {
              RecipeFruit += recipe.total_val['FRU'];
              if (recipe.total_val['override_is_fruit_juice'] > 0) {
                RecipeJuice += recipe.total_val['FRU'];
              }
            }

            if (recipe.total_val['VEG'] > 0) {
              RecipeVeg += recipe.total_val['VEG'];
              if (recipe.total_val['override_is_veg_juice'] > 0) {
                RecipeVegJuice += recipe.total_val['VEG'];
              }
            }

            if (recipe.total_val['WGR'] > 0) {
              TotalGrain.push(recipe.total_val['WGR']);
              if (recipe.total_val['override_is_whole_grains_info'] > 0) {
                TotalWholeGrain.push(recipe.total_val['WGR']);
              }
              if (recipe.total_val['override_is_whole_grains_dessert'] > 0) {
                // TotalWholeGrainDessert.push(recipe.total_val['WGR']);
                TotalWholeGrainDessert += recipe.total_val['WGR'];
              }
            }

            if (recipe.total_val['MLK'] > 0) {
              after_school_cond_4 = true;
              MilkKeys = this.ConvertRecipeToMilkKey(MilkKeys, recipe.total_val);

              if (recipe.total_val['override_is_the_milk_flavored'] > 0) {
                RecipeMilkVariety.is_the_milk_flavored = 1;
              }

              //
              if (['Whole Milk', 'Reduced Fat 2%', 'Low Fat 1%', 'Fat-Free / Skim'].includes(recipe.total_val['override_milk_fat_content'])) {
                RecipeMilkVariety.milk_fat_content = recipe.total_val['override_milk_fat_content'];
              }
            }

            if (RecipeMilkVariety.milk_fat_content != '') {
              MilkVarietyArray.push(RecipeMilkVariety);
            }
          });

          // option.recipes.forEach(recipe => {
          //     let RecipeMilkVariety = { 'is_the_milk_flavored': 0, 'milk_fat_content': '' };

          //     let checkMilk = true;
          //     if (recipe.is_calculation_total_override) {
          //         if (recipe.is_the_milk_flavored == 'Yes') {
          //             RecipeMilkVariety.is_the_milk_flavored = 1;
          //             checkMilk = false;
          //         }

          //         if (['Whole Milk', 'Reduced Fat 2%', 'Low Fat 1%', 'Fat-Free / Skim'].includes(recipe.milk_fat_content)) {
          //             RecipeMilkVariety.milk_fat_content = recipe.milk_fat_content;
          //             checkMilk = false;
          //         }

          //         if (!checkMilk) {
          //             MilkKeys = this.ConvertProductToMilkKey(MilkKeys, recipe);
          //             after_school_cond_4 = true;
          //         }
          //     }

          //     if (recipe?.prefer_products) {
          //         recipe.prefer_products.forEach(product => {

          //             if (product.usda_componenent_serving_meat1 >= 1) {
          //                 after_school_cond_2 = true;
          //             }

          //             // Check Juice Condition
          //             if (product.usda_componenent_serving_fruit1 > 0 || product.usda_componenent_serving_veg1 > 0) {
          //                 after_school_cond_3 = true;
          //             }

          //             if (product.usda_componenent_serving_fruit1 > 0) {
          //                 RecipeFruit += product.usda_componenent_serving_fruit1;
          //                 if (product.is_the_product_juice == 'Yes') {
          //                     RecipeJuice += product.usda_componenent_serving_fruit1;
          //                 }
          //             }

          //             if (product.usda_componenent_serving_veg1 > 0) {
          //                 RecipeVeg += product.usda_componenent_serving_veg1;
          //                 if (product.is_the_product_juice == 'Yes') {
          //                     RecipeVegJuice += product.usda_componenent_serving_veg1;
          //                 }
          //             }

          //             // if (product.usda_componenent_serving_veg1 > 0 && product.is_the_product_juice == 'Yes') {
          //             //     RecipeVegJuice++;
          //             // }


          //             // if (product.usda_componenent_serving_fruit1 > 0  && product.is_the_product_juice == 'Yes') {
          //             //     // RecipeJuice++;
          //             //     RecipeJuice++;
          //             // }

          //             // if (product.usda_componenent_serving_veg1 > 0 && product.is_the_product_juice == 'Yes') {
          //             //     RecipeVegJuice++;
          //             // }

          //             if (checkMilk && product.usda_componenent_serving_milk1 > 0) {
          //                 MilkKeys = this.ConvertProductToMilkKey(MilkKeys, product);
          //                 after_school_cond_4 = true;



          //                 if (product.is_the_milk_flavored == 'Yes') {
          //                     RecipeMilkVariety.is_the_milk_flavored = 1;
          //                 }

          //                 //
          //                 if (['Whole Milk', 'Reduced Fat 2%', 'Low Fat 1%', 'Fat-Free / Skim'].includes(product.milk_fat_content)) {
          //                     RecipeMilkVariety.milk_fat_content = product.milk_fat_content;
          //                 }
          //             }

          //             // Check Grain
          //             let usda_componenent_serving_grain1 = parseInt(product.usda_componenent_serving_grain1);
          //             if (usda_componenent_serving_grain1 > 0) {
          //                 // Sum of total grain
          //                 TotalGrain.push(usda_componenent_serving_grain1);

          //                 if (product.is_whole_grains_info == 'Yes') {
          //                     TotalWholeGrain.push(usda_componenent_serving_grain1);
          //                     if (product.is_whole_grains_dessert == 'Yes') {
          //                         TotalWholeGrainDessert += usda_componenent_serving_grain1;
          //                     }
          //                 }

          //             }

          //         });
          //     }

          //     if (RecipeMilkVariety.milk_fat_content != '') {
          //         MilkVarietyArray.push(RecipeMilkVariety);
          //     }
          // });
          OptionJuice = Math.max(RecipeJuice, OptionJuice);
          OptionFruit = Math.max(RecipeFruit, OptionFruit);

          OptionJuiceVeg = Math.max(RecipeVegJuice, OptionJuiceVeg);
          OptionVeg = Math.max(RecipeVeg, OptionVeg);
        }


        // Fruit Juice
        if (JuiceWeeklyCount.hasOwnProperty(option.day_of_week)) {
          JuiceWeeklyCount[option.day_of_week] = Math.max(JuiceWeeklyCount[option.day_of_week], OptionJuice);
        } else {
          JuiceWeeklyCount[option.day_of_week] = OptionJuice;
        }

        // Fruit
        if (FruitWeeklyCount.hasOwnProperty(option.day_of_week)) {
          FruitWeeklyCount[option.day_of_week] = Math.max(FruitWeeklyCount[option.day_of_week], OptionFruit);
        } else {
          FruitWeeklyCount[option.day_of_week] = OptionFruit;
        }


        // Veg Juice
        if (JuiceVegWeeklyCount.hasOwnProperty(option.day_of_week)) {
          JuiceVegWeeklyCount[option.day_of_week] = Math.max(JuiceVegWeeklyCount[option.day_of_week], OptionJuiceVeg);
        } else {
          JuiceVegWeeklyCount[option.day_of_week] = OptionJuiceVeg;
        }

        // Veg
        if (VegWeeklyCount.hasOwnProperty(option.day_of_week)) {
          VegWeeklyCount[option.day_of_week] = Math.max(VegWeeklyCount[option.day_of_week], OptionVeg);
        } else {
          VegWeeklyCount[option.day_of_week] = OptionVeg;
        }

      });
    }


    if (isJuice) {
      JuiceCount = Object.values(JuiceWeeklyCount).reduce((a, b) => a + b, 0);
      FruitCount = Object.values(FruitWeeklyCount).reduce((a, b) => a + b, 0);

      if (JuiceCount < 0 && FruitCount < 0) {
        isJuice = false;
      } else {
        let jc = JuiceCount / FruitCount * 100;
        if (JuiceCondition >= jc) {
          isJuice = false;
        }
      }
    }

    if (isVegJuice) {
      JuiceVegCount = Object.values(JuiceVegWeeklyCount).reduce((a, b) => a + b, 0);
      VegCount = Object.values(VegWeeklyCount).reduce((a, b) => a + b, 0);

      if (JuiceVegCount < 0 && VegCount < 0) {
        isVegJuice = false;
      } else {
        let jc = JuiceVegCount / VegCount * 100;
        if (JuiceVegCondition >= jc) {
          isVegJuice = false;
        }
      }
    }

    if (isMilk) {
      if (this.CheckMilkCondition(MilkCondition, MilkKeys)) {
        isMilk = false;
      }
    }

    if (isMilkVariety && TargetMilkVariety > 0) {
      // console.log('checkMilkGuideline', this.checkMilkGuideline(gline, MilkVarietyArray, type), MilkVarietyArray, type);
      if (!this.checkMilkGuideline(gline, MilkVarietyArray, type)) {
        returnText.push('Milk Variety : ' + gline[type + '_milk_variety'].description);
      }

    }


    // console.log('isMilkVariety', MilkVarietyArray, MilkVarietyCondition, 'returnText', returnText);

    let sumTotalGrain = TotalGrain.reduce(function (a, b) {
      return parseInt(a) + parseInt(b);
    }, 0);
    let sumTotalWholeGrain = TotalWholeGrain.reduce(function (a, b) {
      return parseInt(a) + parseInt(b);
    }, 0);
    const pGrain = (sumTotalWholeGrain / sumTotalGrain) * 100;

    if (isWholeGrains) {

      if (sumTotalGrain > 0) {
        const percentGrainsServed = gline[type + '_whole_grains'].percent_of_total_grains_served;

        const maxDessertWholeGrain = gline[type + '_whole_grains'].maximum_dessert_whole_grain;

        if (percentGrainsServed && percentGrainsServed >= 0 && maxDessertWholeGrain && maxDessertWholeGrain > 0) {
          if (percentGrainsServed <= pGrain && maxDessertWholeGrain >= TotalWholeGrainDessert) {
            // console.log("isWholeGrains 1");
            isWholeGrains = false;
          }
        } else if (percentGrainsServed && percentGrainsServed <= pGrain) {
          // console.log("isWholeGrains 2");
          isWholeGrains = false;
        } else if (maxDessertWholeGrain && maxDessertWholeGrain >= TotalWholeGrainDessert) {
          // console.log("isWholeGrains 3");
          isWholeGrains = false;
        }
        // console.log("isWholeGrains ", percentGrainsServed, maxDessertWholeGrain, sumTotalGrain, sumTotalWholeGrain, TotalWholeGrainDessert, pGrain, isWholeGrains);
      }
    }


    if (isJuice) {
      returnText.push(gline[type + '_juices'].description);
    }

    if (isVegJuice) {
      returnText.push(gline[type + '_veg_juices'].description);
    }


    if (isMilk) {
      let $this = this;
      MilkConditionArray.forEach(option => {
        // // console.log("MilkCondition ", option);
        if (!$this.CheckMilkCondition(option.condition, MilkKeys)) {
          returnText.push(option.description);
        }
      });
      // returnText.push(gline[type+'_milks_description']);
    }

    // console.log("isWholeGrains last", isWholeGrains);

    if (isWholeGrains) {
      // // console.log("isWholeGrains final", isWholeGrains, gline[type + '_whole_grains'].description);
      returnText.push(gline[type + '_whole_grains'].description);
    }


    if (type == 'daily' && gline.daily_afterschool_snack && gline.daily_afterschool_snack.description) {
      after_school_cond_1 = pGrain >= 50;
      // console.log("after_school_cond", after_school_cond_1, after_school_cond_2, after_school_cond_3, after_school_cond_4, pGrain, sumTotalWholeGrain, sumTotalGrain);
      if (!((after_school_cond_1 && after_school_cond_2) || ((after_school_cond_1 || after_school_cond_2) && (after_school_cond_3 || after_school_cond_4)))) {
        returnText.push(gline.daily_afterschool_snack.description);
      }
    }

    if (returnText.length > 0) {

    }
    console.log('returnText is_additional in ', type, returnText);


    return (returnText.length > 0) ? false : true;
  },

  replaceByDefault(e) {
    // // console.log("replaceByDefault", e.target, e.target.original, e.target.src);
    e.target.src = e.target.getAttribute('original');
  },

  getUnitNickName(unit) {
    let units = { 'Gram': 'g', 'LB': 'lb', 'Kilogram': 'kg', 'Milligram': 'mg' };
    if (units[unit]) {
      return units[unit];
    } else {
      return unit;
    }
  },

  getUniqueNullNutritionKeysWeekCycle(recipesArray) {
    const uniqueKeys = new Set();
    recipesArray.forEach(recipeGroup => {
      if (recipeGroup.recipes && Array.isArray(recipeGroup.recipes)) {
        recipeGroup.recipes.forEach(recipe => {
          if (recipe.all_prefer_products && Array.isArray(recipe.all_prefer_products)) {
            recipe.all_prefer_products.forEach(product => {
              Object.keys(product).forEach(key => {
                if (key.startsWith('nutrition_facts_') && product[key] === null) {
                  uniqueKeys.add(key);
                }
              });
            });
          }
        });
      }
    });

    return Array.from(uniqueKeys);
  },

  getUniqueOverrideComponentsWeekCycle(recipesArray) {
    const uniqueKeys = new Set();
    recipesArray.forEach(recipeGroup => {
      if (recipeGroup.recipes && Array.isArray(recipeGroup.recipes)) {
        recipeGroup.recipes.forEach(recipe => {

          if (recipe.calculation_total_override && typeof recipe.calculation_total_override === "object" && Object.keys(recipe.calculation_total_override).length > 0) {
            Object.keys(recipe.calculation_total_override).forEach(key => {
              uniqueKeys.add(key);
            });
          }
        });
      }
    });

    return Array.from(uniqueKeys);
  },

  getUniqueNullNutritionKeysRecipe(recipesArray) {
    console.log("getUniqueNullNutritionKeysRecipe", recipesArray);
    const uniqueKeys = new Set();
    let nut = ['component_nut_added_sugars', 'component_nut_calories', 'component_nut_carbs', 'component_nut_protein', 'component_nut_satfat', 'component_nut_sodium', 'component_nut_totalfat'];


    recipesArray.forEach(recipe => {
      console.log("getUniqueNullNutritionKeysRecipe recipe",
        recipe, recipe.component_nut_added_sugars);
      nut.forEach(key => {
        if (recipe[key] === null) {
          uniqueKeys.add(key);
        }
      });
    });
    console.log("getUniqueNullNutritionKeysRecipe uniqueKeys", uniqueKeys);

    return Array.from(uniqueKeys);
  }


};
